import colors from "../components/design/colors";

// dashboard
export const dashboardTableToolbarSearchIcon = (
  color = "black" || colors.nc_gray_900,
  height = 39,
  width = 36,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 39 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="38" height="35" rx="2.5" fill="white" />
    <path
      d="M24.75 22.875H14.25C13.8358 22.875 13.5 23.2108 13.5 23.625C13.5 24.0392 13.8358 24.375 14.25 24.375H24.75C25.1642 24.375 25.5 24.0392 25.5 23.625C25.5 23.2108 25.1642 22.875 24.75 22.875Z"
      fill={color}
    />
    <path
      d="M13.5 22.125V23.625C13.5 24.0392 13.8358 24.375 14.25 24.375C14.6642 24.375 15 24.0392 15 23.625V22.125C15 21.7108 14.6642 21.375 14.25 21.375C13.8358 21.375 13.5 21.7108 13.5 22.125Z"
      fill={color}
    />
    <path
      d="M24 22.125V23.625C24 24.0392 24.3358 24.375 24.75 24.375C25.1642 24.375 25.5 24.0392 25.5 23.625V22.125C25.5 21.7108 25.1642 21.375 24.75 21.375C24.3358 21.375 24 21.7108 24 22.125Z"
      fill={color}
    />
    <path
      d="M19.5011 20.625C19.3456 20.6262 19.1936 20.579 19.0661 20.49L16.0661 18.375C15.9044 18.2603 15.7947 18.0862 15.7609 17.8909C15.7272 17.6955 15.7722 17.4948 15.8861 17.3325C15.9429 17.2514 16.0152 17.1823 16.0989 17.1293C16.1826 17.0763 16.2759 17.0404 16.3736 17.0237C16.4712 17.007 16.5711 17.0097 16.6677 17.0318C16.7642 17.0539 16.8555 17.095 16.9361 17.1525L19.5011 18.945L22.0511 17.025C22.2102 16.9057 22.4102 16.8544 22.6071 16.8825C22.804 16.9107 22.9817 17.0159 23.1011 17.175C23.2204 17.3341 23.2717 17.5342 23.2435 17.7311C23.2154 17.928 23.1102 18.1057 22.9511 18.225L19.9511 20.475C19.8212 20.5724 19.6633 20.625 19.5011 20.625Z"
      fill={color}
    />
    <path
      d="M19.5 19.125C19.3011 19.125 19.1103 19.046 18.9697 18.9053C18.829 18.7647 18.75 18.5739 18.75 18.375V12.375C18.75 12.1761 18.829 11.9853 18.9697 11.8447C19.1103 11.704 19.3011 11.625 19.5 11.625C19.6989 11.625 19.8897 11.704 20.0303 11.8447C20.171 11.9853 20.25 12.1761 20.25 12.375V18.375C20.25 18.5739 20.171 18.7647 20.0303 18.9053C19.8897 19.046 19.6989 19.125 19.5 19.125Z"
      fill={color}
    />
    <rect x="0.5" y="0.5" width="38" height="35" rx="2.5" stroke="#DDDDDD" />
  </svg>
);

// new call-logs icons
export const callLogsTableIncomingArrow = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${height} ${width}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1248 5.87522L5.87525 14.1248M5.87525 14.1248V5.87522M5.87525 14.1248H14.1248"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const callLogsTableOutgoingArrow = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.87522 14.1248L14.1248 5.8752M14.1248 5.8752V14.1248M14.1248 5.8752H5.87522"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const callLogsTableBlocked = (
  color = "#E22D20",
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 22 22`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.93 3.93L18.07 18.07M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// calendar icon in date range picker in call-logs
export const callLogsHeaderCalendar = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 8.33317H2.5M13.3333 1.6665V4.99984M6.66667 1.6665V4.99984M6.5 18.3332H13.5C14.9001 18.3332 15.6002 18.3332 16.135 18.0607C16.6054 17.821 16.9878 17.4386 17.2275 16.9681C17.5 16.4334 17.5 15.7333 17.5 14.3332V7.33317C17.5 5.93304 17.5 5.23297 17.2275 4.69819C16.9878 4.22779 16.6054 3.84534 16.135 3.60565C15.6002 3.33317 14.9001 3.33317 13.5 3.33317H6.5C5.09987 3.33317 4.3998 3.33317 3.86502 3.60565C3.39462 3.84534 3.01217 4.22779 2.77248 4.69819C2.5 5.23297 2.5 5.93304 2.5 7.33317V14.3332C2.5 15.7333 2.5 16.4334 2.77248 16.9681C3.01217 17.4386 3.39462 17.821 3.86502 18.0607C4.3998 18.3332 5.09987 18.3332 6.5 18.3332Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// callRecording screen
export const callRecordingPhoneIcon = (
  color = colors.ic_white,
  height = 13,
  width = 13,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 16 16`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.875 12.7501C7.32331 12.7468 4.87707 11.7316 3.07275 9.92732C1.26843 8.123 0.253307 5.67676 0.25 3.12507C0.25 2.36257 0.552901 1.63131 1.09207 1.09214C1.63124 0.552972 2.3625 0.250071 3.125 0.250071C3.28646 0.248842 3.44766 0.263495 3.60625 0.293821C3.75957 0.316509 3.91029 0.35419 4.05625 0.406321C4.15891 0.44234 4.25038 0.50453 4.32163 0.586742C4.39288 0.668953 4.44144 0.768339 4.4625 0.875071L5.31875 4.62507C5.34183 4.72686 5.33905 4.83281 5.31067 4.93325C5.28228 5.03369 5.22919 5.12542 5.15625 5.20007C5.075 5.28757 5.06875 5.29382 4.3 5.69382C4.91562 7.04436 5.99575 8.12892 7.34375 8.75007C7.75 7.97507 7.75625 7.96882 7.84375 7.88757C7.9184 7.81463 8.01013 7.76154 8.11057 7.73316C8.21101 7.70477 8.31696 7.70199 8.41875 7.72507L12.1687 8.58132C12.2721 8.60529 12.3676 8.65516 12.4463 8.72623C12.525 8.7973 12.5844 8.88724 12.6188 8.98757C12.6715 9.13592 12.7112 9.28858 12.7375 9.44382C12.7627 9.6009 12.7752 9.75974 12.775 9.91882C12.7635 10.6781 12.4521 11.4019 11.9087 11.9324C11.3654 12.4628 10.6343 12.7568 9.875 12.7501Z"
      fill={color}
    />
  </svg>
);

export const callRecordingShareIcon = (
  color = colors.ic_white,
  height = 16,
  width = 16,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 16 16`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2496 8.37457C9.75859 8.37497 9.28734 8.56796 8.93709 8.91207L3.99959 6.71207V6.49957V6.29332L8.93709 4.08707C9.24635 4.3902 9.65101 4.57694 10.0823 4.61557C10.5137 4.6542 10.9451 4.54234 11.3033 4.29898C11.6615 4.05563 11.9244 3.69578 12.0474 3.28056C12.1704 2.86534 12.1458 2.42035 11.978 2.02117C11.8101 1.62198 11.5092 1.29321 11.1264 1.0907C10.7436 0.888189 10.3026 0.824419 9.87809 0.910223C9.45362 0.996027 9.07194 1.22611 8.79787 1.5614C8.5238 1.89669 8.37424 2.31652 8.37459 2.74957V2.96207L3.43709 5.16207C3.17357 4.90316 2.83943 4.72788 2.47663 4.65821C2.11383 4.58854 1.73854 4.6276 1.39786 4.77048C1.05718 4.91337 0.766305 5.1537 0.561742 5.46132C0.357179 5.76894 0.248047 6.13014 0.248047 6.49957C0.248047 6.869 0.357179 7.23019 0.561742 7.53781C0.766305 7.84543 1.05718 8.08577 1.39786 8.22865C1.73854 8.37153 2.11383 8.41059 2.47663 8.34093C2.83943 8.27126 3.17357 8.09597 3.43709 7.83707L8.37459 10.0433V10.2496C8.37459 10.6204 8.48456 10.9829 8.69059 11.2913C8.89662 11.5996 9.18945 11.8399 9.53206 11.9818C9.87467 12.1238 10.2517 12.1609 10.6154 12.0885C10.9791 12.0162 11.3132 11.8376 11.5754 11.5754C11.8376 11.3132 12.0162 10.9791 12.0886 10.6154C12.1609 10.2516 12.1238 9.87465 11.9819 9.53204C11.84 9.18942 11.5996 8.89659 11.2913 8.69056C10.9829 8.48453 10.6204 8.37457 10.2496 8.37457Z"
      fill={color}
    />
  </svg>
);

export const callRecordingDownloadIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 19H1M16 9L10 15M10 15L4 9M10 15V1"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const callRecordingSettingsIcon = (
  color = colors.nc_gray_900,
  height = 22,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99854 14C11.6554 14 12.9985 12.6569 12.9985 11C12.9985 9.34314 11.6554 8 9.99854 8C8.34168 8 6.99854 9.34314 6.99854 11C6.99854 12.6569 8.34168 14 9.99854 14Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.28762 18.3711L7.87207 19.6856C8.0458 20.0768 8.32934 20.4093 8.68829 20.6426C9.04724 20.8759 9.46617 21.0001 9.89429 21C10.3224 21.0001 10.7413 20.8759 11.1003 20.6426C11.4592 20.4093 11.7428 20.0768 11.9165 19.6856L12.501 18.3711C12.709 17.9047 13.059 17.5159 13.501 17.26C13.9457 17.0034 14.4603 16.8941 14.971 16.9478L16.401 17.1C16.8266 17.145 17.2562 17.0656 17.6376 16.8713C18.0191 16.6771 18.3359 16.3763 18.5498 16.0056C18.764 15.635 18.8661 15.2103 18.8436 14.7829C18.8211 14.3555 18.6751 13.9438 18.4232 13.5978L17.5765 12.4344C17.275 12.0171 17.1139 11.5148 17.1165 11C17.1164 10.4866 17.279 9.98635 17.581 9.57111L18.4276 8.40778C18.6795 8.06175 18.8255 7.65007 18.848 7.22267C18.8705 6.79528 18.7685 6.37054 18.5543 6C18.3404 5.62923 18.0235 5.32849 17.6421 5.13423C17.2607 4.93996 16.8311 4.86053 16.4054 4.90556L14.9754 5.05778C14.4647 5.11141 13.9502 5.00212 13.5054 4.74556C13.0625 4.48825 12.7125 4.09736 12.5054 3.62889L11.9165 2.31444C11.7428 1.92317 11.4592 1.59072 11.1003 1.3574C10.7413 1.12408 10.3224 0.99993 9.89429 1C9.46617 0.99993 9.04724 1.12408 8.68829 1.3574C8.32934 1.59072 8.0458 1.92317 7.87207 2.31444L7.28762 3.62889C7.08055 4.09736 6.73049 4.48825 6.28762 4.74556C5.84284 5.00212 5.32829 5.11141 4.81762 5.05778L3.38318 4.90556C2.95751 4.86053 2.52792 4.93996 2.14649 5.13423C1.76507 5.32849 1.44819 5.62923 1.23429 6C1.02011 6.37054 0.91807 6.79528 0.940554 7.22267C0.963038 7.65007 1.10908 8.06175 1.36095 8.40778L2.20762 9.57111C2.50956 9.98635 2.67216 10.4866 2.67206 11C2.67216 11.5134 2.50956 12.0136 2.20762 12.4289L1.36095 13.5922C1.10908 13.9382 0.963038 14.3499 0.940554 14.7773C0.91807 15.2047 1.02011 15.6295 1.23429 16C1.4484 16.3706 1.76532 16.6712 2.14668 16.8654C2.52805 17.0596 2.95754 17.1392 3.38318 17.0944L4.81318 16.9422C5.32384 16.8886 5.83839 16.9979 6.28318 17.2544C6.7277 17.511 7.07938 17.902 7.28762 18.3711Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const callRecordingTickIcon = (
  color = "#2EB358",
  height = 11,
  width = 16,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6666 1L5.49992 10.1667L1.33325 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// callRecodring view screen
export const callRecordingGHeaderCopyIcon = (
  color = colors.nc_gray_900, // #464D48
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3318_30510)">
      <path
        d="M13.3332 6.66666V4.33333C13.3332 3.39991 13.3332 2.9332 13.1515 2.57668C12.9917 2.26308 12.7368 2.00811 12.4232 1.84832C12.0666 1.66666 11.5999 1.66666 10.6665 1.66666H4.33317C3.39975 1.66666 2.93304 1.66666 2.57652 1.84832C2.26292 2.00811 2.00795 2.26308 1.84816 2.57668C1.6665 2.9332 1.6665 3.39991 1.6665 4.33333V10.6667C1.6665 11.6001 1.6665 12.0668 1.84816 12.4233C2.00795 12.7369 2.26292 12.9919 2.57652 13.1517C2.93304 13.3333 3.39975 13.3333 4.33317 13.3333H6.6665M9.33317 18.3333H15.6665C16.5999 18.3333 17.0666 18.3333 17.4232 18.1517C17.7368 17.9919 17.9917 17.7369 18.1515 17.4233C18.3332 17.0668 18.3332 16.6001 18.3332 15.6667V9.33333C18.3332 8.39991 18.3332 7.9332 18.1515 7.57668C17.9917 7.26308 17.7368 7.00811 17.4232 6.84832C17.0666 6.66666 16.5999 6.66666 15.6665 6.66666H9.33317C8.39975 6.66666 7.93304 6.66666 7.57652 6.84832C7.26292 7.00811 7.00795 7.26308 6.84816 7.57668C6.6665 7.9332 6.6665 8.39991 6.6665 9.33333V15.6667C6.6665 16.6001 6.6665 17.0668 6.84816 17.4233C7.00795 17.7369 7.26292 17.9919 7.57652 18.1517C7.93304 18.3333 8.39975 18.3333 9.33317 18.3333Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3318_30510">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// call recording screen play/mute recording; play icon
export const callRecordingPlayIcon = (
  color = "#34CB65",
  height = 22,
  width = 19,
) => (
  <svg
    width="49.5"
    height="49.5"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.79 14.9569V33.0422C17.79 34.4213 19.3088 35.2592 20.4784 34.5086L34.6883 25.4659C35.7706 24.7851 35.7706 23.214 34.6883 22.5157L20.4784 13.4905C19.3088 12.7399 17.79 13.5778 17.79 14.9569Z"
      fill={color}
    />
    <rect
      x="1.1"
      y="0.6"
      width="46.8"
      height="46.8"
      rx="5.4"
      stroke={color}
      strokeWidth="1.2"
    />
  </svg>
);

// sharedCallRecording screen
export const sharedCallRecordingClock = (
  color = colors.nc_gray_900,
  height = 16,
  width = 16,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 16 16`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99968 1.33398C6.68113 1.33398 5.3922 1.72498 4.29588 2.45752C3.19955 3.19006 2.34506 4.23125 1.84048 5.44943C1.3359 6.6676 1.20387 8.00805 1.46111 9.30125C1.71834 10.5945 2.35328 11.7823 3.28563 12.7147C4.21798 13.647 5.40587 14.282 6.69907 14.5392C7.99228 14.7965 9.33273 14.6644 10.5509 14.1598C11.7691 13.6553 12.8103 12.8008 13.5428 11.7045C14.2753 10.6081 14.6663 9.31919 14.6663 8.00065C14.6663 7.12517 14.4939 6.25827 14.1589 5.44943C13.8238 4.64059 13.3328 3.90566 12.7137 3.28661C12.0947 2.66755 11.3597 2.17649 10.5509 1.84145C9.74206 1.50642 8.87516 1.33398 7.99968 1.33398ZM7.99968 13.334C6.94484 13.334 5.9137 13.0212 5.03664 12.4352C4.15957 11.8491 3.47599 11.0162 3.07232 10.0416C2.66865 9.06709 2.56303 7.99473 2.76882 6.96017C2.97461 5.9256 3.48256 4.97529 4.22844 4.22941C4.97432 3.48353 5.92463 2.97558 6.9592 2.7698C7.99376 2.56401 9.06612 2.66963 10.0407 3.07329C11.0152 3.47696 11.8481 4.16055 12.4342 5.03761C13.0202 5.91467 13.333 6.94582 13.333 8.00065C13.333 9.41514 12.7711 10.7717 11.7709 11.7719C10.7707 12.7721 9.41416 13.334 7.99968 13.334Z"
      fill={color}
    />
    <path
      d="M10.6663 7.33268H8.66634V5.33268C8.66634 5.15587 8.5961 4.9863 8.47108 4.86128C8.34605 4.73625 8.17649 4.66602 7.99967 4.66602C7.82286 4.66602 7.65329 4.73625 7.52827 4.86128C7.40325 4.9863 7.33301 5.15587 7.33301 5.33268V7.99935C7.33301 8.17616 7.40325 8.34573 7.52827 8.47075C7.65329 8.59578 7.82286 8.66602 7.99967 8.66602H10.6663C10.8432 8.66602 11.0127 8.59578 11.1377 8.47075C11.2628 8.34573 11.333 8.17616 11.333 7.99935C11.333 7.82254 11.2628 7.65297 11.1377 7.52794C11.0127 7.40292 10.8432 7.33268 10.6663 7.33268Z"
      fill={color}
    />
  </svg>
);

export const sharedCallRecordingCalendar = (
  color = colors.nc_gray_900,
  height = 16,
  width = 16,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 16 16`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.66536H11.3333V1.9987C11.3333 1.82189 11.2631 1.65232 11.1381 1.52729C11.013 1.40227 10.8435 1.33203 10.6667 1.33203C10.4899 1.33203 10.3203 1.40227 10.1953 1.52729C10.0702 1.65232 10 1.82189 10 1.9987V2.66536H6V1.9987C6 1.82189 5.92976 1.65232 5.80474 1.52729C5.67971 1.40227 5.51014 1.33203 5.33333 1.33203C5.15652 1.33203 4.98695 1.40227 4.86193 1.52729C4.73691 1.65232 4.66667 1.82189 4.66667 1.9987V2.66536H4C3.46957 2.66536 2.96086 2.87608 2.58579 3.25115C2.21071 3.62622 2 4.13493 2 4.66536V12.6654C2 13.1958 2.21071 13.7045 2.58579 14.0796C2.96086 14.4547 3.46957 14.6654 4 14.6654H12C12.5304 14.6654 13.0391 14.4547 13.4142 14.0796C13.7893 13.7045 14 13.1958 14 12.6654V4.66536C14 4.13493 13.7893 3.62622 13.4142 3.25115C13.0391 2.87608 12.5304 2.66536 12 2.66536ZM4 3.9987H4.66667V4.66536C4.66667 4.84218 4.73691 5.01174 4.86193 5.13677C4.98695 5.26179 5.15652 5.33203 5.33333 5.33203C5.51014 5.33203 5.67971 5.26179 5.80474 5.13677C5.92976 5.01174 6 4.84218 6 4.66536V3.9987H10V4.66536C10 4.84218 10.0702 5.01174 10.1953 5.13677C10.3203 5.26179 10.4899 5.33203 10.6667 5.33203C10.8435 5.33203 11.013 5.26179 11.1381 5.13677C11.2631 5.01174 11.3333 4.84218 11.3333 4.66536V3.9987H12C12.1768 3.9987 12.3464 4.06894 12.4714 4.19396C12.5964 4.31898 12.6667 4.48855 12.6667 4.66536V7.33203H3.33333V4.66536C3.33333 4.48855 3.40357 4.31898 3.5286 4.19396C3.65362 4.06894 3.82319 3.9987 4 3.9987ZM12 13.332H4C3.82319 13.332 3.65362 13.2618 3.5286 13.1368C3.40357 13.0117 3.33333 12.8422 3.33333 12.6654V8.66536H12.6667V12.6654C12.6667 12.8422 12.5964 13.0117 12.4714 13.1368C12.3464 13.2618 12.1768 13.332 12 13.332Z"
      fill={color}
    />
    <path
      d="M5.33366 11.3333C5.70185 11.3333 6.00033 11.0349 6.00033 10.6667C6.00033 10.2985 5.70185 10 5.33366 10C4.96547 10 4.66699 10.2985 4.66699 10.6667C4.66699 11.0349 4.96547 11.3333 5.33366 11.3333Z"
      fill={color}
    />
    <path
      d="M10.6663 10H7.99967C7.82286 10 7.65329 10.0702 7.52827 10.1953C7.40325 10.3203 7.33301 10.4899 7.33301 10.6667C7.33301 10.8435 7.40325 11.013 7.52827 11.1381C7.65329 11.2631 7.82286 11.3333 7.99967 11.3333H10.6663C10.8432 11.3333 11.0127 11.2631 11.1377 11.1381C11.2628 11.013 11.333 10.8435 11.333 10.6667C11.333 10.4899 11.2628 10.3203 11.1377 10.1953C11.0127 10.0702 10.8432 10 10.6663 10Z"
      fill={color}
    />
  </svg>
);

// contactListsView
export const contactListsViewTableCloseIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 5L5.5 15M5.5 5L15.5 15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// voicebroadcast screen
export const voicebroadcastScheduledCallIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99999 5.00008V10.0001L13.3333 11.6667M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
      stroke="#2EB358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const voicebroadcastCancelledCallIcon = (
  color = "#CC4C45",
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style={{ transform: "translate(0, 3)" }}
      d="M12.5 7.50008L7.49999 12.5001M7.49999 7.50008L12.5 12.5001M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const voicebroadcastListenIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width="20"
    height="20"
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(0, 3)">
      <path
        d="M16.4566 1.16669C17.6377 2.80855 18.3333 4.82305 18.3333 7.00002C18.3333 9.17699 17.6377 11.1915 16.4566 12.8334M13.1211 3.66669C13.7801 4.61155 14.1667 5.76065 14.1667 7.00002C14.1667 8.23939 13.7801 9.38849 13.1211 10.3334M8.02859 1.47142L5.39051 4.1095C5.24639 4.25362 5.17432 4.32569 5.09023 4.37722C5.01567 4.42291 4.93438 4.45658 4.84935 4.477C4.75344 4.50002 4.65153 4.50002 4.44771 4.50002H2.99999C2.53328 4.50002 2.29992 4.50002 2.12166 4.59085C1.96486 4.67074 1.83738 4.79823 1.75748 4.95503C1.66666 5.13329 1.66666 5.36664 1.66666 5.83335V8.16669C1.66666 8.6334 1.66666 8.86675 1.75748 9.04501C1.83738 9.20181 1.96486 9.3293 2.12166 9.40919C2.29992 9.50002 2.53328 9.50002 2.99999 9.50002H4.44771C4.65153 9.50002 4.75344 9.50002 4.84935 9.52305C4.93438 9.54346 5.01567 9.57713 5.09023 9.62282C5.17432 9.67436 5.24639 9.74642 5.39051 9.89054L8.02859 12.5286C8.38557 12.8856 8.56406 13.0641 8.7173 13.0761C8.85026 13.0866 8.9802 13.0328 9.06683 12.9314C9.16666 12.8145 9.16666 12.5621 9.16666 12.0572V1.94283C9.16666 1.43798 9.16666 1.18556 9.06683 1.06867C8.9802 0.967252 8.85026 0.913429 8.7173 0.923894C8.56406 0.935955 8.38557 1.11444 8.02859 1.47142Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const voicebroadcastFailedCallIcon = (
  color = "#CC4C45",
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99999 6.66675V10.0001M9.99999 13.3334H10.0083M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const voicebroadcastAnsweredCallIcon = (
  color = colors.nc_gray_900,
  height = 13,
  width = 13,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 13 13`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.00012 11.83L11.8154 1.01465"
      stroke="#34CB65"
      strokeWidth="1.54504"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.61011 1L11.8301 1L11.8301 8.21999"
      stroke="#34CB65"
      strokeWidth="1.54504"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const voicebroadcastNotAnsweredCallIcon = (color = "#CC4C45") => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.828"
    height="16.828"
    viewBox="0 0 16.828 16.828"
  >
    <g transform="translate(1.4, 1.4)">
      <line
        style={{
          fill: "none",
          stroke: color,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5px",
        }}
        y1="14"
        x2="14"
        transform="translate(-0.5, 0.5)"
      />
      <path
        class="a"
        d="M7,7h9.346v9.346"
        transform="translate(-2.327, -7)"
        fill={colors.ic_red_500}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// autodial-modal icons
export const autodialModalResumeIcon = (
  color = colors.ic_white,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2040_1075)">
      <path
        d="M10.0001 18.3334C14.6025 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6025 1.66669 10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.91675 7.47113C7.91675 7.07339 7.91675 6.87452 7.99987 6.7635C8.0723 6.66675 8.18318 6.60622 8.30373 6.59761C8.44207 6.58773 8.60935 6.69527 8.94392 6.91035L12.8777 9.43923C13.1681 9.62587 13.3132 9.71919 13.3634 9.83785C13.4072 9.94152 13.4072 10.0585 13.3634 10.1622C13.3132 10.2809 13.1681 10.3742 12.8777 10.5608L8.94392 13.0897C8.60935 13.3048 8.44207 13.4123 8.30373 13.4024C8.18318 13.3938 8.0723 13.3333 7.99987 13.2365C7.91675 13.1255 7.91675 12.9266 7.91675 12.5289V7.47113Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2040_1075">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const autodialSessionsViewRedialIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33325 16.6667V15.5C3.33325 12.6997 3.33325 11.2996 3.87822 10.2301C4.35759 9.28925 5.12249 8.52434 6.0633 8.04498C7.13286 7.50001 8.53299 7.50001 11.3333 7.50001H16.6666M16.6666 7.50001L12.4999 11.6667M16.6666 7.50001L12.4999 3.33334"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// add-account and signup-screen4(partial, go ⬇️ for the rest of the assets )
export const addAccountSalesIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 16.6667V8.33333M10 16.6667V3.33333M5 16.6667V11.6667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const addAccountRecruitmentIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6665 17.5V5.83333C6.6665 5.05836 6.6665 4.67087 6.75169 4.35295C6.98286 3.49022 7.65673 2.81635 8.51946 2.58519C8.83737 2.5 9.22486 2.5 9.99984 2.5C10.7748 2.5 11.1623 2.5 11.4802 2.58519C12.3429 2.81635 13.0168 3.49022 13.248 4.35295C13.3332 4.67087 13.3332 5.05836 13.3332 5.83333V17.5M4.33317 17.5H15.6665C16.5999 17.5 17.0666 17.5 17.4232 17.3183C17.7368 17.1586 17.9917 16.9036 18.1515 16.59C18.3332 16.2335 18.3332 15.7668 18.3332 14.8333V8.5C18.3332 7.56658 18.3332 7.09987 18.1515 6.74335C17.9917 6.42975 17.7368 6.17478 17.4232 6.01499C17.0666 5.83333 16.5999 5.83333 15.6665 5.83333H4.33317C3.39975 5.83333 2.93304 5.83333 2.57652 6.01499C2.26292 6.17478 2.00795 6.42975 1.84816 6.74335C1.6665 7.09987 1.6665 7.56658 1.6665 8.5V14.8333C1.6665 15.7668 1.6665 16.2335 1.84816 16.59C2.00795 16.9036 2.26292 17.1586 2.57652 17.3183C2.93304 17.5 3.39975 17.5 4.33317 17.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const addAccountSupportIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 15V10C17.5 5.85786 14.1421 2.5 10 2.5C5.85787 2.5 2.5 5.85786 2.5 10V15M4.58333 17.5C3.43274 17.5 2.5 16.5673 2.5 15.4167V13.75C2.5 12.5994 3.43274 11.6667 4.58333 11.6667C5.73393 11.6667 6.66667 12.5994 6.66667 13.75V15.4167C6.66667 16.5673 5.73393 17.5 4.58333 17.5ZM15.4167 17.5C14.2661 17.5 13.3333 16.5673 13.3333 15.4167V13.75C13.3333 12.5994 14.2661 11.6667 15.4167 11.6667C16.5673 11.6667 17.5 12.5994 17.5 13.75V15.4167C17.5 16.5673 16.5673 17.5 15.4167 17.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <line x1="16" y1="17.5" x2="10" y2="17.5" stroke={color} />
    <circle cx="10.5" cy="17.5" r="1.5" fill={color} />
  </svg>
);
export const addAccountOtherIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0002 10.8333C10.4604 10.8333 10.8335 10.4602 10.8335 10C10.8335 9.53976 10.4604 9.16666 10.0002 9.16666C9.53993 9.16666 9.16683 9.53976 9.16683 10C9.16683 10.4602 9.53993 10.8333 10.0002 10.8333Z"
      fill={color}
    />
    <path
      d="M15.8335 10.8333C16.2937 10.8333 16.6668 10.4602 16.6668 10C16.6668 9.53976 16.2937 9.16666 15.8335 9.16666C15.3733 9.16666 15.0002 9.53976 15.0002 10C15.0002 10.4602 15.3733 10.8333 15.8335 10.8333Z"
      fill={color}
    />
    <path
      d="M4.16683 10.8333C4.62707 10.8333 5.00016 10.4602 5.00016 10C5.00016 9.53976 4.62707 9.16666 4.16683 9.16666C3.70659 9.16666 3.3335 9.53976 3.3335 10C3.3335 10.4602 3.70659 10.8333 4.16683 10.8333Z"
      fill={color}
    />
    <path
      d="M10.0002 10.8333C10.4604 10.8333 10.8335 10.4602 10.8335 10C10.8335 9.53976 10.4604 9.16666 10.0002 9.16666C9.53993 9.16666 9.16683 9.53976 9.16683 10C9.16683 10.4602 9.53993 10.8333 10.0002 10.8333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8335 10.8333C16.2937 10.8333 16.6668 10.4602 16.6668 10C16.6668 9.53976 16.2937 9.16666 15.8335 9.16666C15.3733 9.16666 15.0002 9.53976 15.0002 10C15.0002 10.4602 15.3733 10.8333 15.8335 10.8333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16683 10.8333C4.62707 10.8333 5.00016 10.4602 5.00016 10C5.00016 9.53976 4.62707 9.16666 4.16683 9.16666C3.70659 9.16666 3.3335 9.53976 3.3335 10C3.3335 10.4602 3.70659 10.8333 4.16683 10.8333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// generic
// modal close
export const modalCloseIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 7L7 17M7 7L17 17"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// topNav
export const topNavDialPad = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3.33335C10.4602 3.33335 10.8333 2.96026 10.8333 2.50002C10.8333 2.03978 10.4602 1.66669 10 1.66669C9.53976 1.66669 9.16667 2.03978 9.16667 2.50002C9.16667 2.96026 9.53976 3.33335 10 3.33335Z"
      fill={color}
    />
    <path
      d="M10 8.33335C10.4602 8.33335 10.8333 7.96026 10.8333 7.50002C10.8333 7.03978 10.4602 6.66669 10 6.66669C9.53976 6.66669 9.16667 7.03978 9.16667 7.50002C9.16667 7.96026 9.53976 8.33335 10 8.33335Z"
      fill={color}
    />
    <path
      d="M10 13.3334C10.4602 13.3334 10.8333 12.9603 10.8333 12.5C10.8333 12.0398 10.4602 11.6667 10 11.6667C9.53976 11.6667 9.16667 12.0398 9.16667 12.5C9.16667 12.9603 9.53976 13.3334 10 13.3334Z"
      fill={color}
    />
    <path
      d="M15 3.33335C15.4602 3.33335 15.8333 2.96026 15.8333 2.50002C15.8333 2.03978 15.4602 1.66669 15 1.66669C14.5398 1.66669 14.1667 2.03978 14.1667 2.50002C14.1667 2.96026 14.5398 3.33335 15 3.33335Z"
      fill={color}
    />
    <path
      d="M15 8.33335C15.4602 8.33335 15.8333 7.96026 15.8333 7.50002C15.8333 7.03978 15.4602 6.66669 15 6.66669C14.5398 6.66669 14.1667 7.03978 14.1667 7.50002C14.1667 7.96026 14.5398 8.33335 15 8.33335Z"
      fill={color}
    />
    <path
      d="M15 13.3334C15.4602 13.3334 15.8333 12.9603 15.8333 12.5C15.8333 12.0398 15.4602 11.6667 15 11.6667C14.5398 11.6667 14.1667 12.0398 14.1667 12.5C14.1667 12.9603 14.5398 13.3334 15 13.3334Z"
      fill={color}
    />
    <path
      d="M5 3.33335C5.46024 3.33335 5.83333 2.96026 5.83333 2.50002C5.83333 2.03978 5.46024 1.66669 5 1.66669C4.53976 1.66669 4.16667 2.03978 4.16667 2.50002C4.16667 2.96026 4.53976 3.33335 5 3.33335Z"
      fill={color}
    />
    <path
      d="M5 8.33335C5.46024 8.33335 5.83333 7.96026 5.83333 7.50002C5.83333 7.03978 5.46024 6.66669 5 6.66669C4.53976 6.66669 4.16667 7.03978 4.16667 7.50002C4.16667 7.96026 4.53976 8.33335 5 8.33335Z"
      fill={color}
    />
    <path
      d="M5 13.3334C5.46024 13.3334 5.83333 12.9603 5.83333 12.5C5.83333 12.0398 5.46024 11.6667 5 11.6667C4.53976 11.6667 4.16667 12.0398 4.16667 12.5C4.16667 12.9603 4.53976 13.3334 5 13.3334Z"
      fill={color}
    />
    <path
      d="M10 17.9167C10.4602 17.9167 10.8333 17.5436 10.8333 17.0834C10.8333 16.6231 10.4602 16.25 10 16.25C9.53976 16.25 9.16667 16.6231 9.16667 17.0834C9.16667 17.5436 9.53976 17.9167 10 17.9167Z"
      fill={color}
    />
    <path
      d="M10 3.33335C10.4602 3.33335 10.8333 2.96026 10.8333 2.50002C10.8333 2.03978 10.4602 1.66669 10 1.66669C9.53976 1.66669 9.16667 2.03978 9.16667 2.50002C9.16667 2.96026 9.53976 3.33335 10 3.33335Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 8.33335C10.4602 8.33335 10.8333 7.96026 10.8333 7.50002C10.8333 7.03978 10.4602 6.66669 10 6.66669C9.53976 6.66669 9.16667 7.03978 9.16667 7.50002C9.16667 7.96026 9.53976 8.33335 10 8.33335Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.3334C10.4602 13.3334 10.8333 12.9603 10.8333 12.5C10.8333 12.0398 10.4602 11.6667 10 11.6667C9.53976 11.6667 9.16667 12.0398 9.16667 12.5C9.16667 12.9603 9.53976 13.3334 10 13.3334Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 3.33335C15.4602 3.33335 15.8333 2.96026 15.8333 2.50002C15.8333 2.03978 15.4602 1.66669 15 1.66669C14.5398 1.66669 14.1667 2.03978 14.1667 2.50002C14.1667 2.96026 14.5398 3.33335 15 3.33335Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 8.33335C15.4602 8.33335 15.8333 7.96026 15.8333 7.50002C15.8333 7.03978 15.4602 6.66669 15 6.66669C14.5398 6.66669 14.1667 7.03978 14.1667 7.50002C14.1667 7.96026 14.5398 8.33335 15 8.33335Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 13.3334C15.4602 13.3334 15.8333 12.9603 15.8333 12.5C15.8333 12.0398 15.4602 11.6667 15 11.6667C14.5398 11.6667 14.1667 12.0398 14.1667 12.5C14.1667 12.9603 14.5398 13.3334 15 13.3334Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 3.33335C5.46024 3.33335 5.83333 2.96026 5.83333 2.50002C5.83333 2.03978 5.46024 1.66669 5 1.66669C4.53976 1.66669 4.16667 2.03978 4.16667 2.50002C4.16667 2.96026 4.53976 3.33335 5 3.33335Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 8.33335C5.46024 8.33335 5.83333 7.96026 5.83333 7.50002C5.83333 7.03978 5.46024 6.66669 5 6.66669C4.53976 6.66669 4.16667 7.03978 4.16667 7.50002C4.16667 7.96026 4.53976 8.33335 5 8.33335Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 13.3334C5.46024 13.3334 5.83333 12.9603 5.83333 12.5C5.83333 12.0398 5.46024 11.6667 5 11.6667C4.53976 11.6667 4.16667 12.0398 4.16667 12.5C4.16667 12.9603 4.53976 13.3334 5 13.3334Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 17.9167C10.4602 17.9167 10.8333 17.5436 10.8333 17.0834C10.8333 16.6231 10.4602 16.25 10 16.25C9.53976 16.25 9.16667 16.6231 9.16667 17.0834C9.16667 17.5436 9.53976 17.9167 10 17.9167Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const plusIcon = (
  color = colors.ic_green_500,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0001 4.16667V15.8333M4.16675 10H15.8334"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const topNavAccountSelectedAccountTickIcon = (
  color = colors.ic_green_500,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6666 5L7.49992 14.1667L3.33325 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const backIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8334 10L4.16675 10M4.16675 10L10.0001 15.8334M4.16675 10L10.0001 4.16671"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// userd wherever edit-pencil was used; call-logs, autodial-view(threedots is disabled) ...
export const topNavDialerScreen3NotesEditPencilIcon = (
  color = "#4A4A4A",
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5497 5.50465L12.4947 3.44965C12.2265 3.19772 11.8751 3.05317 11.5072 3.04349C11.1394 3.03381 10.7808 3.15968 10.4997 3.39715L3.74973 10.1471C3.50731 10.3916 3.35636 10.7121 3.32223 11.0546L2.99973 14.1822C2.98963 14.292 3.00388 14.4027 3.04148 14.5064C3.07908 14.6102 3.13909 14.7043 3.21723 14.7821C3.28731 14.8517 3.37043 14.9067 3.4618 14.944C3.55318 14.9813 3.65103 15.0002 3.74973 14.9997H3.81723L6.94473 14.7147C7.28733 14.6805 7.60776 14.5296 7.85223 14.2871L14.6022 7.53715C14.8642 7.26037 15.0058 6.89103 14.996 6.51005C14.9861 6.12907 14.8257 5.76753 14.5497 5.50465V5.50465ZM6.80973 13.2147L4.55973 13.4246L4.76223 11.1746L8.99973 6.98965L11.0247 9.01465L6.80973 13.2147ZM11.9997 8.00965L9.98973 5.99965L11.4522 4.49965L13.4997 6.54715L11.9997 8.00965Z"
      fill={color}
    />
  </svg>
);

export const surveyIcon = (stroke = "#464d48", width = "15", height = "18") => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 9.5957V5.3207C13 4.06059 13 3.43053 12.7548 2.94922C12.539 2.52586 12.1948 2.18165 11.7715 1.96594C11.2902 1.7207 10.6601 1.7207 9.4 1.7207H4.6C3.33988 1.7207 2.70982 1.7207 2.22852 1.96594C1.80516 2.18165 1.46095 2.52586 1.24524 2.94922C1 3.43053 1 4.06059 1 5.3207V13.1207C1 14.3808 1 15.0109 1.24524 15.4922C1.46095 15.9155 1.80516 16.2598 2.22852 16.4755C2.70982 16.7207 3.33985 16.7207 4.59989 16.7207H7.375M8.5 8.4707H4M5.5 11.4707H4M10 5.4707H4M11.5 16.7207L13.75 14.4707M13.75 14.4707L11.5 12.2207M13.75 14.4707H9.25"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const noSurveyIcon = () => (
  <svg
    width="25"
    height="29"
    viewBox="0 0 25 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1668 13.166H7.16683M9.8335 18.4993H7.16683M17.8335 7.83268H7.16683M23.1668 7.56602V21.4327C23.1668 23.6729 23.1668 24.793 22.7309 25.6486C22.3474 26.4013 21.7354 27.0132 20.9828 27.3967C20.1271 27.8327 19.007 27.8327 16.7668 27.8327H8.2335C5.99329 27.8327 4.87318 27.8327 4.01753 27.3967C3.26489 27.0132 2.65296 26.4013 2.26947 25.6486C1.8335 24.793 1.8335 23.6729 1.8335 21.4327V7.56602C1.8335 5.32581 1.8335 4.2057 2.26947 3.35005C2.65296 2.59741 3.26489 1.98548 4.01753 1.60199C4.87318 1.16602 5.99329 1.16602 8.2335 1.16602H16.7668C19.007 1.16602 20.1271 1.16602 20.9828 1.60199C21.7354 1.98548 22.3474 2.59741 22.7309 3.35005C23.1668 4.2057 23.1668 5.32581 23.1668 7.56602Z"
      stroke="#3F3F46"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const topNavNotificationIcon = (
  stroke = "#464d48",
  height = "20px",
  width = "20px",
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.79642 17.5013C8.38403 18.0199 9.15591 18.3346 10.0013 18.3346C10.8466 18.3346 11.6185 18.0199 12.2061 17.5013M15.0013 6.66797C15.0013 5.34189 14.4745 4.07012 13.5368 3.13243C12.5991 2.19475 11.3274 1.66797 10.0013 1.66797C8.6752 1.66797 7.40343 2.19475 6.46574 3.13243C5.52806 4.07012 5.00128 5.34189 5.00128 6.66797C5.00128 9.24312 4.35167 11.0063 3.626 12.1725C3.01388 13.1562 2.70783 13.6481 2.71905 13.7853C2.73147 13.9372 2.76366 13.9951 2.88609 14.086C2.99666 14.168 3.4951 14.168 4.49199 14.168H15.5106C16.5075 14.168 17.0059 14.168 17.1165 14.086C17.2389 13.9951 17.2711 13.9372 17.2835 13.7853C17.2947 13.6481 16.9887 13.1562 16.3766 12.1725C15.6509 11.0063 15.0013 9.24312 15.0013 6.66797Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const muteCallIcon = (stroke = "#464D48") => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4443_299)">
      <path
        d="M11.5833 7.27046V3.97046C11.5833 2.72782 10.5759 1.72046 9.33325 1.72046C8.45004 1.72046 7.68569 2.22935 7.31741 2.96991M9.33325 14.4705V16.7205M9.33325 14.4705C6.43376 14.4705 4.08325 12.12 4.08325 9.22046V7.72046M9.33325 14.4705C12.2327 14.4705 14.5833 12.12 14.5833 9.22046V7.72046M6.33325 16.7205H12.3333M1.83325 1.72046L16.8333 16.7205M9.33325 11.4705C8.09061 11.4705 7.08325 10.4631 7.08325 9.22046V6.97046L10.9252 10.8105C10.518 11.2182 9.95506 11.4705 9.33325 11.4705Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4443_299">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.333252 0.220459)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const holdCallIcon = (stroke = "#464D48") => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.91667 12.7205V7.72046M12.0833 12.7205V7.72046M6.5 17.7205H13.5C14.9001 17.7205 15.6002 17.7205 16.135 17.448C16.6054 17.2083 16.9878 16.8258 17.2275 16.3554C17.5 15.8207 17.5 15.1206 17.5 13.7205V6.72046C17.5 5.32033 17.5 4.62026 17.2275 4.08548C16.9878 3.61508 16.6054 3.23263 16.135 2.99294C15.6002 2.72046 14.9001 2.72046 13.5 2.72046H6.5C5.09987 2.72046 4.3998 2.72046 3.86502 2.99294C3.39462 3.23263 3.01217 3.61508 2.77248 4.08548C2.5 4.62026 2.5 5.32033 2.5 6.72046V13.7205C2.5 15.1206 2.5 15.8207 2.77248 16.3554C3.01217 16.8258 3.39462 17.2083 3.86502 17.448C4.3998 17.7205 5.09987 17.7205 6.5 17.7205Z"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const endCallIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon" clipPath="url(#clip0_4442_728)">
      <path
        id="Icon_2"
        d="M17.0807 12.9802C15.5635 12.4473 13.9319 12.1575 12.2326 12.1575C10.5333 12.1575 8.90174 12.4473 7.38456 12.9802C7.25406 13.026 7.18881 13.0489 7.11676 13.0884C6.86073 13.2289 6.65881 13.5138 6.61114 13.8019C6.59773 13.883 6.59773 13.9638 6.59773 14.1255C6.59773 14.6199 6.59773 14.8671 6.55425 15.0722C6.39027 15.8457 5.78599 16.45 5.0125 16.614C4.80739 16.6575 4.56018 16.6575 4.06576 16.6575L3.79018 16.6575C3.0386 16.6575 2.66282 16.6575 2.35896 16.5577C1.75464 16.3594 1.28069 15.8854 1.08235 15.2811C0.982626 14.9773 0.982626 14.6015 0.982626 13.8499V13.627C0.982626 12.878 0.982626 12.5035 1.0942 12.1059C1.218 11.6647 1.54265 11.1118 1.86763 10.7888C2.1605 10.4977 2.4167 10.3547 2.92911 10.0689C5.68284 8.53277 8.85551 7.65745 12.2326 7.65745C15.6097 7.65745 18.7824 8.53277 21.5361 10.0689C22.0486 10.3547 22.3048 10.4977 22.5976 10.7888C22.9226 11.1118 23.2473 11.6647 23.3711 12.1059C23.4826 12.5035 23.4826 12.878 23.4826 13.627V13.8499C23.4826 14.6015 23.4826 14.9773 23.3829 15.2811C23.1846 15.8854 22.7106 16.3594 22.1063 16.5577C21.8024 16.6575 21.4266 16.6575 20.6751 16.6575L20.3995 16.6575C19.9051 16.6575 19.6579 16.6575 19.4528 16.614C18.6793 16.45 18.075 15.8457 17.911 15.0722C17.8675 14.8671 17.8675 14.6199 17.8675 14.1255C17.8675 13.9638 17.8675 13.883 17.8541 13.8019C17.8064 13.5138 17.6045 13.2289 17.3485 13.0884C17.2764 13.0489 17.2112 13.026 17.0807 12.9802Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4442_728">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.220459)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const initiateOrAcceptCallIcon = (color = "white") => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.78521 6.64001C7.30721 7.72723 8.0188 8.74621 8.91998 9.64739C9.82116 10.5486 10.8401 11.2602 11.9274 11.7822C12.0209 11.8271 12.0676 11.8495 12.1268 11.8668C12.3371 11.9281 12.5953 11.884 12.7733 11.7565C12.8234 11.7206 12.8663 11.6778 12.952 11.592C13.2143 11.3298 13.3454 11.1987 13.4772 11.113C13.9744 10.7898 14.6153 10.7898 15.1125 11.113C15.2443 11.1987 15.3754 11.3298 15.6376 11.592L15.7838 11.7382C16.1823 12.1368 16.3816 12.3361 16.4899 12.5501C16.7052 12.9758 16.7052 13.4785 16.4899 13.9041C16.3816 14.1182 16.1823 14.3175 15.7838 14.7161L15.6655 14.8343C15.2683 15.2315 15.0697 15.4301 14.7997 15.5818C14.5 15.7501 14.0347 15.8711 13.691 15.8701C13.3813 15.8692 13.1696 15.8091 12.7463 15.6889C10.4713 15.0432 8.32448 13.8249 6.53349 12.0339C4.74251 10.2429 3.52415 8.09612 2.87843 5.82108C2.75827 5.39774 2.69819 5.18607 2.69727 4.87636C2.69625 4.5327 2.81727 4.06733 2.98559 3.7677C3.13727 3.49768 3.33588 3.29907 3.7331 2.90185L3.85132 2.78362C4.24991 2.38504 4.4492 2.18575 4.66323 2.07749C5.0889 1.86219 5.5916 1.86219 6.01727 2.07749C6.23131 2.18575 6.4306 2.38504 6.82918 2.78362L6.97533 2.92978C7.23754 3.19198 7.36864 3.32308 7.45435 3.45492C7.7776 3.95208 7.7776 4.59302 7.45435 5.09019C7.36864 5.22202 7.23754 5.35312 6.97533 5.61533C6.8896 5.70106 6.84673 5.74393 6.81085 5.79404C6.68334 5.97211 6.63932 6.2303 6.70061 6.44057C6.71786 6.49974 6.74031 6.5465 6.78521 6.64001Z"
      fill={color}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// signup connect-number (signup screen 3)
export const signupScreen3ButtonBackIcon = (
  color = colors.nc_gray_900,
  height = 11,
  width = 7,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 7 11`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.4999 10.4589C5.67514 10.4592 5.84497 10.4015 5.9799 10.2959C6.05584 10.2365 6.11862 10.1635 6.16464 10.081C6.21065 9.99862 6.239 9.90845 6.24805 9.81567C6.25711 9.7229 6.2467 9.62935 6.21742 9.54038C6.18813 9.45141 6.14055 9.36877 6.0774 9.29719L2.7174 5.50053L5.9574 1.69678C6.0197 1.62432 6.06622 1.54096 6.0943 1.45147C6.12237 1.36197 6.13144 1.26813 6.12099 1.17531C6.11053 1.0825 6.08076 0.992558 6.03338 0.910649C5.986 0.828739 5.92195 0.756481 5.8449 0.698028C5.7673 0.633543 5.67643 0.584904 5.57798 0.555162C5.47953 0.525419 5.37564 0.515217 5.27282 0.525194C5.17 0.53517 5.07047 0.565111 4.98049 0.613138C4.8905 0.661164 4.812 0.726239 4.7499 0.804278L1.1274 5.05428C1.01709 5.18102 0.956785 5.34 0.956785 5.50407C0.956785 5.66814 1.01709 5.82712 1.1274 5.95386L4.8774 10.2039C4.95264 10.2896 5.04821 10.3573 5.15637 10.4016C5.26453 10.446 5.38222 10.4656 5.4999 10.4589Z"
      fill={color}
    />
  </svg>
);

// sideNav
export const sideNavUsersTeamsGroupIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3327 17.5V15.8333C18.3327 14.2801 17.2704 12.9751 15.8327 12.605M12.916 2.7423C14.1376 3.23679 14.9993 4.43443 14.9993 5.83333C14.9993 7.23224 14.1376 8.42988 12.916 8.92437M14.166 17.5C14.166 15.9469 14.166 15.1703 13.9123 14.5577C13.574 13.741 12.9251 13.092 12.1083 12.7537C11.4957 12.5 10.7192 12.5 9.16602 12.5H6.66602C5.11288 12.5 4.33631 12.5 3.72374 12.7537C2.90698 13.092 2.25806 13.741 1.91975 14.5577C1.66602 15.1703 1.66602 15.9469 1.66602 17.5M11.2493 5.83333C11.2493 7.67428 9.75696 9.16667 7.91602 9.16667C6.07507 9.16667 4.58268 7.67428 4.58268 5.83333C4.58268 3.99238 6.07507 2.5 7.91602 2.5C9.75696 2.5 11.2493 3.99238 11.2493 5.83333Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sideNavDashboardIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 16.6666V8.33331M10 16.6666V3.33331M5 16.6666V11.6666"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sideNavCallLogsIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.9166 11.25L17.2505 9.58333L15.5833 11.25M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C12.7516 2.5 15.1571 3.98178 16.4621 6.19091M10 5.83333V10L12.5 11.6667"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sideNavCampaignsIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3333 6.66666V9.99999M8.54166 4.58332H5.66666C4.26653 4.58332 3.56647 4.58332 3.03169 4.8558C2.56128 5.09549 2.17883 5.47794 1.93915 5.94835C1.66666 6.48313 1.66666 7.18319 1.66666 8.58332L1.66666 9.58332C1.66667 10.3599 1.66667 10.7482 1.79353 11.0545C1.96269 11.4628 2.28715 11.7873 2.69553 11.9565C3.00181 12.0833 3.3901 12.0833 4.16667 12.0833V15.625C4.16667 15.8185 4.16667 15.9152 4.17469 15.9967C4.25263 16.788 4.87868 17.414 5.66997 17.492C5.75145 17.5 5.84819 17.5 6.04167 17.5C6.23514 17.5 6.33188 17.5 6.41336 17.492C7.20466 17.414 7.83071 16.788 7.90864 15.9967C7.91667 15.9152 7.91667 15.8185 7.91667 15.625V12.0833H8.54167C10.0137 12.0833 11.8144 12.8724 13.2036 13.6297C14.014 14.0715 14.4192 14.2924 14.6846 14.2599C14.9307 14.2297 15.1168 14.1192 15.2611 13.9176C15.4167 13.7001 15.4167 13.265 15.4167 12.3947V4.27189C15.4167 3.40165 15.4167 2.96653 15.2611 2.74906C15.1168 2.54741 14.9307 2.4369 14.6846 2.40676C14.4192 2.37426 14.014 2.59515 13.2036 3.03695C11.8144 3.79425 10.0137 4.58332 8.54166 4.58332Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const sideNavContactListsIcon =  (color=colors.nc_gray_900, height=20, width=20) => <svg  width={width} height={height} viewBox={`0 0 20 20`} fill="none" xmlns="http://www.w3.org/2000/svg">
// 	<path d="M17.5 10.0001L7.5 10.0001M17.5 5.00008L7.5 5.00008M17.5 15.0001L7.5 15.0001M4.16667 10.0001C4.16667 10.4603 3.79357 10.8334 3.33333 10.8334C2.8731 10.8334 2.5 10.4603 2.5 10.0001C2.5 9.53984 2.8731 9.16675 3.33333 9.16675C3.79357 9.16675 4.16667 9.53984 4.16667 10.0001ZM4.16667 5.00008C4.16667 5.46032 3.79357 5.83341 3.33333 5.83341C2.8731 5.83341 2.5 5.46032 2.5 5.00008C2.5 4.53984 2.8731 4.16675 3.33333 4.16675C3.79357 4.16675 4.16667 4.53984 4.16667 5.00008ZM4.16667 15.0001C4.16667 15.4603 3.79357 15.8334 3.33333 15.8334C2.8731 15.8334 2.5 15.4603 2.5 15.0001C2.5 14.5398 2.8731 14.1667 3.33333 14.1667C3.79357 14.1667 4.16667 14.5398 4.16667 15.0001Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
// </svg>

// export const sideNavVoiceBroadcastIcon =  (color=colors.nc_gray_900, height=20, width=20) => <svg  width={width} height={height} viewBox={`0 0 20 20`} fill="none" xmlns="http://www.w3.org/2000/svg">
// 	<path d="M2.5 8.33333L2.5 11.6667M6.25 5L6.25 15M10 2.5V17.5M13.75 5V15M17.5 8.33333V11.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
// </svg>

// export const sideNavSettingsIcon =  (color=colors.nc_gray_900, height=20, width=20) => <svg  width={width} height={height} viewBox={`0 0 20 20`} fill="none" xmlns="http://www.w3.org/2000/svg">
// 	<path d="M9.99878 12.5C11.3795 12.5 12.4988 11.3807 12.4988 9.99999C12.4988 8.61928 11.3795 7.49999 9.99878 7.49999C8.61807 7.49999 7.49878 8.61928 7.49878 9.99999C7.49878 11.3807 8.61807 12.5 9.99878 12.5Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
// 	<path d="M7.73968 16.1426L8.22672 17.238C8.3715 17.564 8.60778 17.8411 8.90691 18.0355C9.20603 18.2299 9.55514 18.3334 9.91191 18.3333C10.2687 18.3334 10.6178 18.2299 10.9169 18.0355C11.216 17.8411 11.4523 17.564 11.5971 17.238L12.0841 16.1426C12.2575 15.7539 12.5491 15.4299 12.9175 15.2167C13.2881 15.0029 13.7169 14.9118 14.1425 14.9565L15.3341 15.0833C15.6889 15.1208 16.0468 15.0546 16.3647 14.8928C16.6826 14.7309 16.9466 14.4803 17.1249 14.1713C17.3034 13.8625 17.3884 13.5086 17.3696 13.1524C17.3509 12.7962 17.2292 12.4532 17.0193 12.1648L16.3138 11.1954C16.0625 10.8476 15.9283 10.429 15.9304 9.99999C15.9303 9.57215 16.0658 9.15528 16.3175 8.80925L17.023 7.8398C17.2329 7.55145 17.3546 7.20838 17.3733 6.85222C17.3921 6.49605 17.3071 6.14211 17.1286 5.83332C16.9503 5.52435 16.6863 5.27373 16.3684 5.11185C16.0505 4.94996 15.6926 4.88377 15.3378 4.92129L14.1462 5.04814C13.7206 5.09283 13.2918 5.00176 12.9212 4.78795C12.5521 4.57353 12.2604 4.24779 12.0878 3.8574L11.5971 2.76203C11.4523 2.43597 11.216 2.15892 10.9169 1.96449C10.6178 1.77006 10.2687 1.6666 9.91191 1.66666C9.55514 1.6666 9.20603 1.77006 8.90691 1.96449C8.60778 2.15892 8.3715 2.43597 8.22672 2.76203L7.73968 3.8574C7.56712 4.24779 7.27541 4.57353 6.90635 4.78795C6.5357 5.00176 6.10691 5.09283 5.68135 5.04814L4.48598 4.92129C4.13125 4.88377 3.77326 4.94996 3.45541 5.11185C3.13755 5.27373 2.87349 5.52435 2.69524 5.83332C2.51676 6.14211 2.43172 6.49605 2.45046 6.85222C2.4692 7.20838 2.5909 7.55145 2.80079 7.8398L3.50635 8.80925C3.75797 9.15528 3.89346 9.57215 3.89339 9.99999C3.89346 10.4278 3.75797 10.8447 3.50635 11.1907L2.80079 12.1602C2.5909 12.4485 2.4692 12.7916 2.45046 13.1478C2.43172 13.5039 2.51676 13.8579 2.69524 14.1667C2.87367 14.4755 3.13776 14.726 3.45557 14.8878C3.77338 15.0497 4.13128 15.116 4.48598 15.0787L5.67765 14.9518C6.1032 14.9071 6.53199 14.9982 6.90265 15.212C7.27309 15.4258 7.56615 15.7517 7.73968 16.1426Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
// </svg>

export const sideNavContactListsIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 10.0001L7.5 10.0001M17.5 5.00008L7.5 5.00008M17.5 15.0001L7.5 15.0001M4.16667 10.0001C4.16667 10.4603 3.79357 10.8334 3.33333 10.8334C2.8731 10.8334 2.5 10.4603 2.5 10.0001C2.5 9.53984 2.8731 9.16675 3.33333 9.16675C3.79357 9.16675 4.16667 9.53984 4.16667 10.0001ZM4.16667 5.00008C4.16667 5.46032 3.79357 5.83341 3.33333 5.83341C2.8731 5.83341 2.5 5.46032 2.5 5.00008C2.5 4.53984 2.8731 4.16675 3.33333 4.16675C3.79357 4.16675 4.16667 4.53984 4.16667 5.00008ZM4.16667 15.0001C4.16667 15.4603 3.79357 15.8334 3.33333 15.8334C2.8731 15.8334 2.5 15.4603 2.5 15.0001C2.5 14.5398 2.8731 14.1667 3.33333 14.1667C3.79357 14.1667 4.16667 14.5398 4.16667 15.0001Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sideNavVoiceBroadcastIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 8.33333L2.5 11.6667M6.25 5L6.25 15M10 2.5V17.5M13.75 5V15M17.5 8.33333V11.6667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const sideNavPlatformRulesIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3603_3632)">
      <path
        d="M10.0001 13.3333V9.99999M10.0001 6.66666H10.0084M18.3334 9.99999C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 9.99999C1.66675 5.39762 5.39771 1.66666 10.0001 1.66666C14.6025 1.66666 18.3334 5.39762 18.3334 9.99999Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3603_3632">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const sideNavBillingIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3334 8.33329H1.66669M1.66669 6.83329L1.66669 13.1666C1.66669 14.1 1.66669 14.5668 1.84834 14.9233C2.00813 15.2369 2.2631 15.4918 2.5767 15.6516C2.93322 15.8333 3.39993 15.8333 4.33335 15.8333L15.6667 15.8333C16.6001 15.8333 17.0668 15.8333 17.4233 15.6516C17.7369 15.4918 17.9919 15.2369 18.1517 14.9233C18.3334 14.5668 18.3334 14.1 18.3334 13.1666V6.83329C18.3334 5.89987 18.3334 5.43316 18.1517 5.07664C17.9919 4.76304 17.7369 4.50807 17.4233 4.34828C17.0668 4.16663 16.6001 4.16663 15.6667 4.16663L4.33335 4.16663C3.39993 4.16663 2.93322 4.16663 2.5767 4.34828C2.2631 4.50807 2.00813 4.76304 1.84834 5.07664C1.66669 5.43316 1.66669 5.89987 1.66669 6.83329Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const sideNavSettingsIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99878 12.5C11.3795 12.5 12.4988 11.3807 12.4988 9.99999C12.4988 8.61928 11.3795 7.49999 9.99878 7.49999C8.61807 7.49999 7.49878 8.61928 7.49878 9.99999C7.49878 11.3807 8.61807 12.5 9.99878 12.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.73968 16.1426L8.22672 17.238C8.3715 17.564 8.60778 17.8411 8.90691 18.0355C9.20603 18.2299 9.55514 18.3334 9.91191 18.3333C10.2687 18.3334 10.6178 18.2299 10.9169 18.0355C11.216 17.8411 11.4523 17.564 11.5971 17.238L12.0841 16.1426C12.2575 15.7539 12.5491 15.4299 12.9175 15.2167C13.2881 15.0029 13.7169 14.9118 14.1425 14.9565L15.3341 15.0833C15.6889 15.1208 16.0468 15.0546 16.3647 14.8928C16.6826 14.7309 16.9466 14.4803 17.1249 14.1713C17.3034 13.8625 17.3884 13.5086 17.3696 13.1524C17.3509 12.7962 17.2292 12.4532 17.0193 12.1648L16.3138 11.1954C16.0625 10.8476 15.9283 10.429 15.9304 9.99999C15.9303 9.57215 16.0658 9.15528 16.3175 8.80925L17.023 7.8398C17.2329 7.55145 17.3546 7.20838 17.3733 6.85222C17.3921 6.49605 17.3071 6.14211 17.1286 5.83332C16.9503 5.52435 16.6863 5.27373 16.3684 5.11185C16.0505 4.94996 15.6926 4.88377 15.3378 4.92129L14.1462 5.04814C13.7206 5.09283 13.2918 5.00176 12.9212 4.78795C12.5521 4.57353 12.2604 4.24779 12.0878 3.8574L11.5971 2.76203C11.4523 2.43597 11.216 2.15892 10.9169 1.96449C10.6178 1.77006 10.2687 1.6666 9.91191 1.66666C9.55514 1.6666 9.20603 1.77006 8.90691 1.96449C8.60778 2.15892 8.3715 2.43597 8.22672 2.76203L7.73968 3.8574C7.56712 4.24779 7.27541 4.57353 6.90635 4.78795C6.5357 5.00176 6.10691 5.09283 5.68135 5.04814L4.48598 4.92129C4.13125 4.88377 3.77326 4.94996 3.45541 5.11185C3.13755 5.27373 2.87349 5.52435 2.69524 5.83332C2.51676 6.14211 2.43172 6.49605 2.45046 6.85222C2.4692 7.20838 2.5909 7.55145 2.80079 7.8398L3.50635 8.80925C3.75797 9.15528 3.89346 9.57215 3.89339 9.99999C3.89346 10.4278 3.75797 10.8447 3.50635 11.1907L2.80079 12.1602C2.5909 12.4485 2.4692 12.7916 2.45046 13.1478C2.43172 13.5039 2.51676 13.8579 2.69524 14.1667C2.87367 14.4755 3.13776 14.726 3.45557 14.8878C3.77338 15.0497 4.13128 15.116 4.48598 15.0787L5.67765 14.9518C6.1032 14.9071 6.53199 14.9982 6.90265 15.212C7.27309 15.4258 7.56615 15.7517 7.73968 16.1426Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const sideNavKybIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 9.58333L9.16667 11.25L12.9167 7.5M16.6667 10C16.6667 14.0904 12.205 17.0653 10.5816 18.0124C10.3971 18.12 10.3048 18.1738 10.1746 18.2018C10.0736 18.2234 9.92638 18.2234 9.82536 18.2018C9.69513 18.1738 9.60288 18.12 9.41838 18.0124C7.79501 17.0653 3.33334 14.0904 3.33334 10V6.01467C3.33334 5.34841 3.33334 5.01528 3.44231 4.72892C3.53857 4.47595 3.695 4.25023 3.89806 4.07127C4.12792 3.86868 4.43984 3.75171 5.06368 3.51777L9.53185 1.84221C9.70509 1.7772 9.79171 1.7447 9.88083 1.73181C9.95987 1.72039 10.0401 1.72039 10.1192 1.73181C10.2083 1.7447 10.2949 1.7772 10.4682 1.84221L14.9363 3.51777C15.5602 3.75171 15.8721 3.86868 16.1019 4.07127C16.305 4.25023 16.4614 4.47595 16.5577 4.72892C16.6667 5.01528 16.6667 5.34841 16.6667 6.01467V10Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const sideNavTemplatesIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0833 5.06478L8.99997 8.99996M8.99997 8.99996L1.91664 5.06478M8.99997 8.99996L9 16.9167M16.5 12.3821V5.61786C16.5 5.33232 16.5 5.18956 16.4579 5.06222C16.4207 4.94958 16.3599 4.84618 16.2795 4.75893C16.1886 4.66032 16.0638 4.59099 15.8142 4.45232L9.64753 1.02639C9.41119 0.895093 9.29302 0.829443 9.16788 0.803706C9.05712 0.780926 8.94288 0.780926 8.83213 0.803706C8.70698 0.829443 8.58881 0.895093 8.35248 1.02639L2.18581 4.45232C1.93621 4.59099 1.8114 4.66032 1.72053 4.75894C1.64013 4.84618 1.57929 4.94958 1.54207 5.06223C1.5 5.18956 1.5 5.33233 1.5 5.61786V12.3821C1.5 12.6677 1.5 12.8104 1.54207 12.9378C1.57929 13.0504 1.64013 13.1538 1.72053 13.241C1.8114 13.3397 1.93621 13.409 2.18581 13.5477L8.35248 16.9736C8.58881 17.1049 8.70698 17.1705 8.83213 17.1963C8.94288 17.219 9.05712 17.219 9.16788 17.1963C9.29302 17.1705 9.41119 17.1049 9.64753 16.9736L15.8142 13.5477C16.0638 13.409 16.1886 13.3397 16.2795 13.241C16.3599 13.1538 16.4207 13.0504 16.4579 12.9378C16.5 12.8104 16.5 12.6677 16.5 12.3821Z"
      stroke="#464D48"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// users screen icons
export const usersAddUserIcon = (
  color = colors.ic_white,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.99935 12.9167H6.24935C5.08638 12.9167 4.50489 12.9167 4.03173 13.0602C2.96639 13.3834 2.13272 14.217 1.80955 15.2824C1.66602 15.7555 1.66602 16.337 1.66602 17.5M15.8327 17.5V12.5M13.3327 15H18.3327M12.0827 6.25C12.0827 8.32107 10.4038 10 8.33268 10C6.26161 10 4.58268 8.32107 4.58268 6.25C4.58268 4.17893 6.26161 2.5 8.33268 2.5C10.4038 2.5 12.0827 4.17893 12.0827 6.25Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const oauthGreenTickIcon = (
  color = colors.ic_green_500,
  height = 17,
  width = 16,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 4.5L5.99996 11.8333L2.66663 8.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const oauthLinkIcon = (
  color = colors.nc_gray_800,
  height = 24,
  width = 34,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3179_28326)">
      <path
        d="M8.00049 17L6.00049 17C3.23906 17 1.00049 14.7614 1.00049 12C1.00049 9.23854 3.23906 6.99996 6.00049 6.99996H8.00049M16.0005 17H18.0005C20.7619 17 23.0005 14.7614 23.0005 12C23.0005 9.23854 20.7619 6.99996 18.0005 6.99996H16.0005M7.05076 11.9999L16.9503 11.9999"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3179_28326">
        <rect width={width} height={height} fill={colors.ic_white} />
      </clipPath>
    </defs>
  </svg>
);

export const oauthErrorIcon = () => (
  <svg
    width="55"
    height="54"
    viewBox="0 0 55 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.5 18V27M27.5 36H27.5225M50 27C50 39.4264 39.9264 49.5 27.5 49.5C15.0736 49.5 5 39.4264 5 27C5 14.5736 15.0736 4.5 27.5 4.5C39.9264 4.5 50 14.5736 50 27Z"
      stroke="#E0544C"
      strokeWidth="4.05"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// shared icons

// phone icon in table
export const sharedTablePhoneIcon = (
  color = colors.nc_gray_900,
  height = 16,
  width = 16,
) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 20 20`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.58685 5.90223C6.05085 6.86865 6.68337 7.77441 7.48443 8.57546C8.28548 9.37651 9.19124 10.009 10.1577 10.473C10.2408 10.5129 10.2823 10.5329 10.3349 10.5482C10.5218 10.6027 10.7513 10.5636 10.9096 10.4502C10.9542 10.4183 10.9923 10.3802 11.0685 10.304C11.3016 10.071 11.4181 9.95443 11.5353 9.87824C11.9772 9.59091 12.5469 9.59091 12.9889 9.87824C13.106 9.95443 13.2226 10.071 13.4556 10.304L13.5856 10.4339C13.9399 10.7882 14.117 10.9654 14.2132 11.1556C14.4046 11.534 14.4046 11.9809 14.2132 12.3592C14.117 12.5495 13.9399 12.7266 13.5856 13.0809L13.4805 13.186C13.1274 13.5391 12.9508 13.7156 12.7108 13.8505C12.4445 14.0001 12.0308 14.1077 11.7253 14.1068C11.45 14.1059 11.2619 14.0525 10.8856 13.9457C8.86333 13.3718 6.95509 12.2888 5.36311 10.6968C3.77112 9.10479 2.68814 7.19655 2.11416 5.17429C2.00735 4.79799 1.95395 4.60984 1.95313 4.33455C1.95222 4.02906 2.0598 3.6154 2.20941 3.34907C2.34424 3.10905 2.52078 2.9325 2.87386 2.57942L2.97895 2.47433C3.33325 2.12004 3.5104 1.94289 3.70065 1.84666C4.07903 1.65528 4.52587 1.65528 4.90424 1.84666C5.0945 1.94289 5.27164 2.12004 5.62594 2.47433L5.75585 2.60424C5.98892 2.83732 6.10546 2.95385 6.18165 3.07104C6.46898 3.51296 6.46898 4.08268 6.18165 4.52461C6.10546 4.6418 5.98892 4.75833 5.75585 4.9914C5.67964 5.06761 5.64154 5.10571 5.60965 5.15026C5.4963 5.30854 5.45717 5.53805 5.51165 5.72495C5.52698 5.77755 5.54694 5.81911 5.58685 5.90223Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// voice broadcast icon
export const voiceBroadcastIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={"0 0 20 20"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.5 7.33333L1.5 10.6667M5.25 4L5.25 14M9 1.5V16.5M12.75 4V14M16.5 7.33333V10.6667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const resendIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={"0 0 20 20"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.33331 14.6667V13.5C1.33331 10.6998 1.33331 9.29965 1.87828 8.23009C2.35765 7.28928 3.12255 6.52437 4.06336 6.04501C5.13292 5.50004 6.53305 5.50004 9.33331 5.50004H14.6666M14.6666 5.50004L10.5 9.66671M14.6666 5.50004L10.5 1.33337"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const virtualNumbersIcon = (
  color = colors.nc_gray_900,
  height = 20,
  width = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox={"0 0 20 20"}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.98356 6.37769C6.56356 7.58571 7.35422 8.71791 8.35553 9.71923C9.35685 10.7205 10.4891 11.5112 11.6971 12.0912C11.801 12.1411 11.8529 12.166 11.9187 12.1852C12.1523 12.2533 12.4392 12.2044 12.637 12.0627C12.6927 12.0228 12.7403 11.9752 12.8356 11.8799C13.1269 11.5886 13.2726 11.4429 13.4191 11.3477C13.9715 10.9885 14.6837 10.9885 15.2361 11.3477C15.3825 11.4429 15.5282 11.5886 15.8196 11.8799L15.9819 12.0423C16.4248 12.4852 16.6462 12.7066 16.7665 12.9445C17.0058 13.4174 17.0058 13.976 16.7665 14.4489C16.6462 14.6868 16.4248 14.9082 15.9819 15.3511L15.8506 15.4824C15.4092 15.9238 15.1886 16.1445 14.8885 16.313C14.5556 16.5 14.0385 16.6345 13.6567 16.6333C13.3126 16.6323 13.0774 16.5656 12.607 16.4321C10.0792 15.7146 7.69387 14.3609 5.70388 12.3709C3.7139 10.3809 2.36017 7.99559 1.6427 5.46776C1.50919 4.99739 1.44244 4.76221 1.44141 4.41808C1.44028 4.03623 1.57475 3.51916 1.76176 3.18623C1.9303 2.88621 2.15098 2.66553 2.59233 2.22418L2.72369 2.09282C3.16656 1.64995 3.388 1.42851 3.62581 1.30823C4.09878 1.069 4.65734 1.069 5.1303 1.30823C5.36812 1.42851 5.58955 1.64995 6.03242 2.09282L6.19481 2.25521C6.48615 2.54655 6.63182 2.69221 6.72706 2.8387C7.08622 3.39111 7.08622 4.10326 6.72706 4.65566C6.63182 4.80215 6.48615 4.94782 6.19481 5.23915C6.09955 5.33441 6.05192 5.38204 6.01206 5.43772C5.87038 5.63558 5.82146 5.92246 5.88957 6.15609C5.90873 6.22183 5.93367 6.27379 5.98356 6.37769Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const threeDotsIcon = () => {
  return (
    <svg
      width="14"
      height="4"
      viewBox="0 0 14 4"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99999 2.66668C7.36818 2.66668 7.66666 2.3682 7.66666 2.00001C7.66666 1.63182 7.36818 1.33334 6.99999 1.33334C6.6318 1.33334 6.33332 1.63182 6.33332 2.00001C6.33332 2.3682 6.6318 2.66668 6.99999 2.66668Z"
        fill="#464D48"
      />
      <path
        d="M11.6667 2.66668C12.0348 2.66668 12.3333 2.3682 12.3333 2.00001C12.3333 1.63182 12.0348 1.33334 11.6667 1.33334C11.2985 1.33334 11 1.63182 11 2.00001C11 2.3682 11.2985 2.66668 11.6667 2.66668Z"
        fill="#464D48"
      />
      <path
        d="M2.33332 2.66668C2.70151 2.66668 2.99999 2.3682 2.99999 2.00001C2.99999 1.63182 2.70151 1.33334 2.33332 1.33334C1.96513 1.33334 1.66666 1.63182 1.66666 2.00001C1.66666 2.3682 1.96513 2.66668 2.33332 2.66668Z"
        fill="#464D48"
      />
      <path
        d="M6.99999 2.66668C7.36818 2.66668 7.66666 2.3682 7.66666 2.00001C7.66666 1.63182 7.36818 1.33334 6.99999 1.33334C6.6318 1.33334 6.33332 1.63182 6.33332 2.00001C6.33332 2.3682 6.6318 2.66668 6.99999 2.66668Z"
        stroke="#464D48"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 2.66668C12.0348 2.66668 12.3333 2.3682 12.3333 2.00001C12.3333 1.63182 12.0348 1.33334 11.6667 1.33334C11.2985 1.33334 11 1.63182 11 2.00001C11 2.3682 11.2985 2.66668 11.6667 2.66668Z"
        stroke="#464D48"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33332 2.66668C2.70151 2.66668 2.99999 2.3682 2.99999 2.00001C2.99999 1.63182 2.70151 1.33334 2.33332 1.33334C1.96513 1.33334 1.66666 1.63182 1.66666 2.00001C1.66666 2.3682 1.96513 2.66668 2.33332 2.66668Z"
        stroke="#464D48"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const dropdownIcon = (color = colors.nc_gray_900) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.5L6 6.5L11 1.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const playButtonIcon = () => (
  <svg
    width="96"
    height="66"
    viewBox="0 0 96 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.825"
      y="0.825"
      width="94.35"
      height="64.35"
      rx="7.425"
      fill="white"
    />
    <path
      d="M37 20.43V45.57C37 47.487 39.2297 48.6518 40.9468 47.6083L61.8083 35.0384C63.3972 34.092 63.3972 31.908 61.8083 30.9374L40.9468 18.3917C39.2297 17.3482 37 18.513 37 20.43Z"
      fill="#34CB65"
    />
    <rect
      x="0.825"
      y="0.825"
      width="94.35"
      height="64.35"
      rx="7.425"
      stroke="#34CB65"
      strokeWidth="1.65"
    />
  </svg>
);

export const errorIcon = (color = "#cc4c45", height = "16", width = "16") => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4855_1417)">
      <path
        d="M7.99967 5.33337V8.00004M7.99967 10.6667H8.00634M14.6663 8.00004C14.6663 11.6819 11.6816 14.6667 7.99967 14.6667C4.31778 14.6667 1.33301 11.6819 1.33301 8.00004C1.33301 4.31814 4.31778 1.33337 7.99967 1.33337C11.6816 1.33337 14.6663 4.31814 14.6663 8.00004Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4855_1417">
        <rect width={width} height={height} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const deleteIcon = (stroke = "#464d48", width = "32", height = "32") => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.3333 11V10.3333C19.3333 9.39987 19.3333 8.93316 19.1517 8.57664C18.9919 8.26304 18.7369 8.00807 18.4233 7.84828C18.0668 7.66663 17.6001 7.66663 16.6667 7.66663H15.3333C14.3999 7.66663 13.9332 7.66663 13.5767 7.84828C13.2631 8.00807 13.0081 8.26304 12.8483 8.57664C12.6667 8.93316 12.6667 9.39987 12.6667 10.3333V11M8.5 11H23.5M21.8333 11V20.3333C21.8333 21.7334 21.8333 22.4335 21.5608 22.9683C21.3212 23.4387 20.9387 23.8211 20.4683 24.0608C19.9335 24.3333 19.2335 24.3333 17.8333 24.3333H14.1667C12.7665 24.3333 12.0665 24.3333 11.5317 24.0608C11.0613 23.8211 10.6788 23.4387 10.4392 22.9683C10.1667 22.4335 10.1667 21.7334 10.1667 20.3333V11"
      stroke={stroke}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const messageIcon = (
  stroke = "#464d48",
  width = "18",
  height = "18",
  fill = "none",
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M2.25 5.85C2.25 4.58988 2.25 3.95982 2.49524 3.47852C2.71095 3.05516 3.05516 2.71095 3.47852 2.49524C3.95982 2.25 4.58988 2.25 5.85 2.25H12.15C13.4101 2.25 14.0402 2.25 14.5215 2.49524C14.9448 2.71095 15.289 3.05516 15.5048 3.47852C15.75 3.95982 15.75 4.58988 15.75 5.85V9.9C15.75 11.1601 15.75 11.7902 15.5048 12.2715C15.289 12.6948 14.9448 13.039 14.5215 13.2548C14.0402 13.5 13.4101 13.5 12.15 13.5H7.26281C6.79477 13.5 6.56075 13.5 6.33691 13.5459C6.13832 13.5867 5.94615 13.6541 5.76561 13.7463C5.56213 13.8503 5.37939 13.9965 5.01391 14.2889L3.22482 15.7201C2.91275 15.9698 2.75672 16.0946 2.6254 16.0948C2.5112 16.0949 2.40317 16.043 2.33192 15.9537C2.25 15.8511 2.25 15.6513 2.25 15.2516V5.85Z"
      stroke={stroke}
      fill={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const callIcon = (
  stroke = "#464d48",
  width = "16",
  height = "16",
  fill = "none",
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.28521 5.63989C5.80721 6.72711 6.5188 7.74609 7.41998 8.64727C8.32116 9.54845 9.34014 10.26 10.4274 10.782C10.5209 10.8269 10.5676 10.8494 10.6268 10.8666C10.8371 10.9279 11.0953 10.8839 11.2733 10.7564C11.3234 10.7205 11.3663 10.6777 11.452 10.5919C11.7143 10.3297 11.8454 10.1986 11.9772 10.1129C12.4744 9.78965 13.1153 9.78965 13.6125 10.1129C13.7443 10.1986 13.8754 10.3297 14.1376 10.5919L14.2837 10.7381C14.6823 11.1367 14.8816 11.3359 14.9899 11.55C15.2052 11.9756 15.2052 12.4783 14.9899 12.904C14.8816 13.1181 14.6823 13.3173 14.2837 13.7159L14.1655 13.8342C13.7683 14.2314 13.5697 14.43 13.2997 14.5817C13 14.75 12.5347 14.871 12.191 14.87C11.8813 14.8691 11.6696 14.809 11.2463 14.6888C8.97125 14.0431 6.82448 12.8247 5.03349 11.0338C3.24251 9.24277 2.02415 7.096 1.37843 4.82095C1.25827 4.39762 1.19819 4.18595 1.19727 3.87624C1.19625 3.53258 1.31727 3.06721 1.48559 2.76758C1.63727 2.49755 1.83588 2.29894 2.2331 1.90173L2.35132 1.7835C2.74991 1.38492 2.9492 1.18563 3.16323 1.07737C3.5889 0.862068 4.0916 0.862068 4.51727 1.07737C4.73131 1.18563 4.9306 1.38492 5.32918 1.7835L5.47533 1.92965C5.73754 2.19186 5.86864 2.32296 5.95435 2.45479C6.2776 2.95196 6.2776 3.5929 5.95435 4.09007C5.86864 4.2219 5.73754 4.353 5.47533 4.61521C5.3896 4.70094 5.34673 4.74381 5.31085 4.79392C5.18334 4.97199 5.13932 5.23018 5.20061 5.44045C5.21786 5.49962 5.24031 5.54637 5.28521 5.63989Z"
      stroke={stroke}
      fill={fill}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const UseWebAppPc = () => (
  <svg
    width="44"
    height="40"
    viewBox="0 0 44 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 38H30M22 30V38M11.6 30H32.4C35.7603 30 37.4405 30 38.7239 29.346C39.8529 28.7708 40.7708 27.8529 41.346 26.7239C42 25.4405 42 23.7603 42 20.4V11.6C42 8.23969 42 6.55953 41.346 5.27606C40.7708 4.14708 39.8529 3.2292 38.7239 2.65396C37.4405 2 35.7603 2 32.4 2H11.6C8.23969 2 6.55953 2 5.27606 2.65396C4.14708 3.2292 3.2292 4.14708 2.65396 5.27606C2 6.55953 2 8.23969 2 11.6V20.4C2 23.7603 2 25.4405 2.65396 26.7239C3.2292 27.8529 4.14708 28.7708 5.27606 29.346C6.55953 30 8.23969 30 11.6 30Z"
      stroke="#2EB358"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CalendarIcon = () => (
  <svg
    width="14"
    height="20"
    viewBox="0 0 14 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 6.66668H1M9.66667 1.33334V4.00001M4.33333 1.33334V4.00001M4.2 14.6667H9.8C10.9201 14.6667 11.4802 14.6667 11.908 14.4487C12.2843 14.2569 12.5903 13.951 12.782 13.5747C13 13.1468 13 12.5868 13 11.4667V5.86668C13 4.74657 13 4.18652 12.782 3.7587C12.5903 3.38237 12.2843 3.07641 11.908 2.88466C11.4802 2.66668 10.9201 2.66668 9.8 2.66668H4.2C3.0799 2.66668 2.51984 2.66668 2.09202 2.88466C1.71569 3.07641 1.40973 3.38237 1.21799 3.7587C1 4.18652 1 4.74657 1 5.86668V11.4667C1 12.5868 1 13.1468 1.21799 13.5747C1.40973 13.951 1.71569 14.2569 2.09202 14.4487C2.51984 14.6667 3.0799 14.6667 4.2 14.6667Z"
      stroke="#919994"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const filledStar = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2249 8.49573C19.1646 8.3104 19.0042 8.17534 18.8111 8.14736L13.386 7.36028L10.9597 2.4523C10.8734 2.27759 10.6952 2.16699 10.5 2.16699C10.3049 2.16699 10.1266 2.27759 10.0403 2.4523L7.61394 7.36028L2.18896 8.14736C1.99588 8.17534 1.83541 8.3104 1.77512 8.4957C1.71479 8.68103 1.7651 8.88444 1.90486 9.02043L5.83032 12.8408L4.90378 18.2352C4.87076 18.4273 4.94985 18.6213 5.10773 18.7359C5.19704 18.8006 5.30282 18.8336 5.40912 18.8336C5.49074 18.8336 5.57264 18.8142 5.64763 18.7748L10.5 16.2278L15.3522 18.7748C15.5249 18.8654 15.7342 18.8503 15.8921 18.7358C16.05 18.6213 16.1291 18.4272 16.0961 18.2352L15.1693 12.8408L19.0952 9.02039C19.2349 8.88444 19.2852 8.68103 19.2249 8.49573Z"
      fill="#FF492C"
    />
  </svg>
);
export const halfFilledStar = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2249 8.49577C19.1646 8.31041 19.0042 8.17538 18.811 8.1474L13.386 7.36029L10.9598 2.4523C10.8734 2.27755 10.6952 2.16699 10.5 2.16699C10.3049 2.16699 10.1266 2.27755 10.0403 2.4523L7.61392 7.36026L2.18897 8.1474C1.99588 8.17538 1.83538 8.31041 1.77512 8.49571C1.71479 8.68107 1.7651 8.88448 1.90483 9.02043L5.83029 12.8408L4.90375 18.2352C4.87077 18.4273 4.94986 18.6214 5.10774 18.7359C5.26561 18.8504 5.47486 18.8655 5.64767 18.7748L10.5 16.2279L15.3522 18.7748C15.4272 18.8142 15.5091 18.8336 15.5907 18.8336C15.697 18.8336 15.8028 18.8007 15.8921 18.7359C16.05 18.6214 16.1291 18.4273 16.0961 18.2352L15.1693 12.8408L19.0951 9.02043C19.2349 8.88445 19.2852 8.68103 19.2249 8.49577Z"
      fill="#FF492C"
    />
    <path
      d="M19.2249 8.49578C19.1646 8.31042 19.0041 8.17539 18.811 8.14741L13.386 7.3603L10.9598 2.45231C10.8734 2.27755 10.6952 2.16699 10.5 2.16699V16.2279L15.3522 18.7749C15.4272 18.8142 15.5091 18.8337 15.5907 18.8337C15.697 18.8337 15.8028 18.8007 15.8921 18.736C16.05 18.6214 16.1291 18.4273 16.0961 18.2353L15.1693 12.8408L19.0951 9.02044C19.2349 8.88446 19.2852 8.68104 19.2249 8.49578Z"
      fill="#DCDEDC"
    />
  </svg>
);
export const playIcon = () => (
  <svg
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 2.50945C1 1.8181 1 1.47242 1.14263 1.28187C1.26688 1.11587 1.45679 1.01315 1.66238 1.00074C1.89837 0.986498 2.18295 1.17824 2.75212 1.56174L10.1589 6.55229C10.6292 6.86916 10.8643 7.0276 10.9463 7.2273C11.0179 7.40189 11.0179 7.59811 10.9463 7.7727C10.8643 7.9724 10.6292 8.13084 10.1589 8.44771L2.75212 13.4383C2.18295 13.8218 1.89837 14.0135 1.66238 13.9993C1.45679 13.9869 1.26688 13.8841 1.14263 13.7181C1 13.5276 1 13.1819 1 12.4905V2.50945Z"
      fill="#2EB358"
      stroke="#2EB358"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const completedIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.74984 10.0003L9.24984 12.5003L14.2498 7.50033M18.8332 10.0003C18.8332 14.6027 15.1022 18.3337 10.4998 18.3337C5.89746 18.3337 2.1665 14.6027 2.1665 10.0003C2.1665 5.39795 5.89746 1.66699 10.4998 1.66699C15.1022 1.66699 18.8332 5.39795 18.8332 10.0003Z"
      stroke="#2EB358"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const uploadIcon = () => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 10V10.8C14.5 11.9201 14.5 12.4802 14.282 12.908C14.0903 13.2843 13.7843 13.5903 13.408 13.782C12.9802 14 12.4201 14 11.3 14H5.7C4.57989 14 4.01984 14 3.59202 13.782C3.21569 13.5903 2.90973 13.2843 2.71799 12.908C2.5 12.4802 2.5 11.9201 2.5 10.8V10M11.8333 5.33333L8.5 2M8.5 2L5.16667 5.33333M8.5 2V10"
      stroke="#464D48"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const checkboxCheckedAll = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="17"
      rx="3.5"
      fill="#34CB65"
      stroke="#34CB65"
    />
    <path
      d="M5.5 9H12.5"
      stroke="white"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const checkboxUncheck = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="17"
      height="17"
      rx="3.5"
      fill="white"
      stroke="#C6CCC8"
    />
  </svg>
);
export const checkboxCheck = () => (
  <svg
    width="24"
    height="21"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="17" height="17" rx="3.5" fill="#34CB65" />
    <rect x="0.5" y="0.5" width="17" height="17" rx="3.5" stroke="#34CB65" />
    <path
      d="M13 6L7.5 11.5L5 9"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chevronLeft = (
  width = "20",
  height = "20",
  color = "#219848",
  style = {},
) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 18L9 12L15 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const link = (width = "18", height = "18", color = "#3F3F46") => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.58955 14.3034L8.41104 15.4819C6.78386 17.1091 4.14567 17.1091 2.51848 15.4819C0.891299 13.8547 0.8913 11.2165 2.51848 9.58931L3.697 8.4108M14.3036 9.58931L15.4821 8.4108C17.1093 6.78361 17.1093 4.14542 15.4821 2.51824C13.8549 0.891055 11.2167 0.891056 9.58955 2.51824L8.41104 3.69675M6.08363 11.9167L11.917 6.08337"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const stars = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 13L7.28446 14.5689C7.54995 15.0999 7.68269 15.3654 7.86003 15.5954C8.01739 15.7996 8.20041 15.9826 8.40455 16.14C8.63462 16.3173 8.9001 16.4501 9.43108 16.7155L11 17.5L9.43108 18.2845C8.9001 18.5499 8.63462 18.6827 8.40455 18.86C8.20041 19.0174 8.01739 19.2004 7.86003 19.4046C7.68269 19.6346 7.54995 19.9001 7.28446 20.4311L6.5 22L5.71554 20.4311C5.45005 19.9001 5.31731 19.6346 5.13997 19.4046C4.98261 19.2004 4.79959 19.0174 4.59545 18.86C4.36538 18.6827 4.0999 18.5499 3.56892 18.2845L2 17.5L3.56892 16.7155C4.0999 16.4501 4.36538 16.3173 4.59545 16.14C4.79959 15.9826 4.98261 15.7996 5.13997 15.5954C5.31731 15.3654 5.45005 15.0999 5.71554 14.5689L6.5 13Z"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 2L16.1786 5.06442C16.4606 5.79765 16.6016 6.16426 16.8209 6.47264C17.0153 6.74595 17.254 6.98475 17.5274 7.17909C17.8357 7.39836 18.2024 7.53937 18.9356 7.82138L22 9L18.9356 10.1786C18.2024 10.4606 17.8357 10.6016 17.5274 10.8209C17.254 11.0153 17.0153 11.254 16.8209 11.5274C16.6016 11.8357 16.4606 12.2024 16.1786 12.9356L15 16L13.8214 12.9356C13.5394 12.2024 13.3984 11.8357 13.1791 11.5274C12.9847 11.254 12.746 11.0153 12.4726 10.8209C12.1643 10.6016 11.7976 10.4606 11.0644 10.1786L8 9L11.0644 7.82138C11.7976 7.53937 12.1643 7.39836 12.4726 7.17909C12.746 6.98475 12.9847 6.74595 13.1791 6.47264C13.3984 6.16426 13.5394 5.79765 13.8214 5.06442L15 2Z"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const infoCircle = (
  color = "#A0A0AB",
  width = 13.33,
  height = 13.33,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const check = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 6L9 17L4 12"
      stroke="#ffffff"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const searchIcon = (color = "#70707B") => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 21L15.0001 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const downloadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 15V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V15M17 10L12 15M12 15L7 10M12 15V3"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const userAndTeamIcon = (color = colors.nc_gray_900) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke={color}
      d="M18.3337 17.5V15.8333C18.3337 14.2801 17.2713 12.9751 15.8337 12.605M12.917 2.7423C14.1386 3.23679 15.0003 4.43443 15.0003 5.83333C15.0003 7.23224 14.1386 8.42988 12.917 8.92437M14.167 17.5C14.167 15.9469 14.167 15.1703 13.9133 14.5577C13.5749 13.741 12.926 13.092 12.1093 12.7537C11.4967 12.5 10.7201 12.5 9.16699 12.5H6.66699C5.11385 12.5 4.33728 12.5 3.72471 12.7537C2.90795 13.092 2.25904 13.741 1.92073 14.5577C1.66699 15.1703 1.66699 15.9469 1.66699 17.5M11.2503 5.83333C11.2503 7.67428 9.75794 9.16667 7.91699 9.16667C6.07604 9.16667 4.58366 7.67428 4.58366 5.83333C4.58366 3.99238 6.07604 2.5 7.91699 2.5C9.75794 2.5 11.2503 3.99238 11.2503 5.83333Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const lockIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 10V8C17 5.23858 14.7614 3 12 3C9.23858 3 7 5.23858 7 8V10M12 14.5V16.5M8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C17.7202 10 16.8802 10 15.2 10H8.8C7.11984 10 6.27976 10 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21Z"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const triggerIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z"
      stroke="#219848"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 7.96533C8.5 7.48805 8.5 7.24941 8.59974 7.11618C8.68666 7.00007 8.81971 6.92744 8.96438 6.9171C9.13038 6.90525 9.33112 7.03429 9.73261 7.29239L14.4532 10.3271C14.8016 10.551 14.9758 10.663 15.0359 10.8054C15.0885 10.9298 15.0885 11.0702 15.0359 11.1946C14.9758 11.337 14.8016 11.449 14.4532 11.6729L9.73261 14.7076C9.33112 14.9657 9.13038 15.0948 8.96438 15.0829C8.81971 15.0726 8.68666 14.9999 8.59974 14.8838C8.5 14.7506 8.5 14.512 8.5 14.0347V7.96533Z"
      stroke="#219848"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const layersTwo = (
  color = colors.nc_gray_900,
  width = 20,
  height = 20,
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 14.5L11.6422 19.3211C11.7734 19.3867 11.839 19.4195 11.9078 19.4324C11.9687 19.4438 12.0313 19.4438 12.0922 19.4324C12.161 19.4195 12.2266 19.3867 12.3578 19.3211L22 14.5M2 9.5L11.6422 4.67889C11.7734 4.6133 11.839 4.5805 11.9078 4.5676C11.9687 4.55616 12.0313 4.55616 12.0922 4.5676C12.161 4.5805 12.2266 4.6133 12.3578 4.67889L22 9.5L12.3578 14.3211C12.2266 14.3867 12.161 14.4195 12.0922 14.4324C12.0313 14.4438 11.9687 14.4438 11.9078 14.4324C11.839 14.4195 11.7734 14.3867 11.6422 14.3211L2 9.5Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const messageSent = (width = 20, height = 20) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2498 5L8.33317 15L4.1665 11.25"
      stroke="#A0A0AB"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const messageDelivered = (width = 20, height = 20) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 5L5.41667 15L1.25 11.25M18.7502 5L10.8335 15L9.5835 13.75"
      stroke="#A0A0AB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const messageRead = (width = 20, height = 20) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3333 4.83337L5.41667 14.8334L1.25 11.0834M18.7502 4.83337L10.8335 14.8334L9.5835 13.5834"
      stroke="#34B1FD"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const userIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 21C20 19.6044 20 18.9067 19.8278 18.3389C19.44 17.0605 18.4395 16.06 17.1611 15.6722C16.5933 15.5 15.8956 15.5 14.5 15.5H9.5C8.10444 15.5 7.40665 15.5 6.83886 15.6722C5.56045 16.06 4.56004 17.0605 4.17224 18.3389C4 18.9067 4 19.6044 4 21M16.5 7.5C16.5 9.98528 14.4853 12 12 12C9.51472 12 7.5 9.98528 7.5 7.5C7.5 5.01472 9.51472 3 12 3C14.4853 3 16.5 5.01472 16.5 7.5Z"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowLeft = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12H5M5 12L12 19M5 12L12 5"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowRight = (stroke = "#3F3F46") => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 8H15M15 8L8 1M15 8L8 15"
      stroke={stroke}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const clock = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99971 4.64V7.99996L10.2397 9.11995M13.5996 7.99996C13.5996 11.0927 11.0925 13.5999 7.99971 13.5999C4.90696 13.5999 2.39978 11.0927 2.39978 7.99996C2.39978 4.9072 4.90696 2.40002 7.99971 2.40002C11.0925 2.40002 13.5996 4.9072 13.5996 7.99996Z"
      stroke="#A0A0AB"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const refreshIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4993 8.33333C17.4993 8.33333 15.8285 6.05685 14.4712 4.69854C13.1138 3.34022 11.238 2.5 9.16602 2.5C5.02388 2.5 1.66602 5.85786 1.66602 10C1.66602 14.1421 5.02388 17.5 9.16602 17.5C12.5853 17.5 15.4701 15.2119 16.3729 12.0833M17.4993 8.33333V3.33333M17.4993 8.33333H12.4993"
      stroke="#464D48"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chevronRight = (
  color = "#3F3F46",
  width = 24,
  height = 24,
  style = {},
) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18L15 12L9 6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const filterLines = (width = "24", height = "24") => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 12H18M3 6H21M9 18H15"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const chevronDown = (color = "#3F3F46", width = 24, height = 24) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 9L12 15L18 9"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const settings02 = (width = 24, height = 24) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0505 9H5.5C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4H15.0505M8.94949 20H18.5C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15H8.94949M3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14C4.567 14 3 15.567 3 17.5ZM21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const minusIcon = (width = "24", height = "24") => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 12H19"
      stroke="#3F3F46"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const fileIcon = (color = "#3F3F46", width = "24", height = "24") => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const browserCallingIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="43" height="43" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="43" height="43" rx="5.5" stroke="#AEEAC1" />
    <path
      d="M32.8333 27.4167V23.0833C32.8333 17.1002 27.983 12.25 22 12.25C16.0169 12.25 11.1666 17.1002 11.1666 23.0833V27.4167M17.125 31.75C15.6292 31.75 14.4166 30.5374 14.4166 29.0417V25.7917C14.4166 24.2959 15.6292 23.0833 17.125 23.0833C18.6207 23.0833 19.8333 24.2959 19.8333 25.7917V29.0417C19.8333 30.5374 18.6207 31.75 17.125 31.75ZM26.875 31.75C25.3792 31.75 24.1666 30.5374 24.1666 29.0417V25.7917C24.1666 24.2959 25.3792 23.0833 26.875 23.0833C28.3707 23.0833 29.5833 24.2959 29.5833 25.7917V29.0417C29.5833 30.5374 28.3707 31.75 26.875 31.75Z"
      stroke="#2AA251"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const autodialIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="43" height="43" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="43" height="43" rx="5.5" stroke="#AEEAC1" />
    <path
      d="M23.0834 11.1667L13.4346 22.7452C13.0568 23.1986 12.8678 23.4254 12.8649 23.6168C12.8624 23.7833 12.9366 23.9417 13.0661 24.0463C13.215 24.1667 13.5102 24.1667 14.1004 24.1667H22.0001L20.9167 32.8333L30.5655 21.2548C30.9434 20.8014 31.1323 20.5747 31.1352 20.3832C31.1377 20.2167 31.0635 20.0583 30.934 19.9537C30.7851 19.8333 30.4899 19.8333 29.8997 19.8333H22.0001L23.0834 11.1667Z"
      stroke="#2AA251"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const whatsappIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="43" height="43" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="43" height="43" rx="5.5" stroke="#AEEAC1" />
    <path
      d="M32.2917 22C32.2917 27.775 27.684 32.4565 22 32.4565C20.6311 32.4565 19.3246 32.185 18.1298 31.692C17.9011 31.5976 17.7868 31.5504 17.6944 31.5294C17.604 31.5088 17.5371 31.5013 17.4444 31.5012C17.3497 31.5012 17.2465 31.5187 17.0402 31.5536L12.9717 32.2426C12.5456 32.3147 12.3326 32.3508 12.1786 32.2837C12.0437 32.2249 11.9363 32.1158 11.8785 31.9788C11.8124 31.8223 11.8479 31.6058 11.9189 31.173L12.597 27.0393C12.6314 26.8296 12.6486 26.7248 12.6486 26.6286C12.6486 26.5345 12.6412 26.4665 12.6209 26.3746C12.6002 26.2807 12.5537 26.1646 12.4609 25.9322C11.9757 24.7183 11.7084 23.3909 11.7084 22C11.7084 16.225 16.3161 11.5435 22 11.5435C27.684 11.5435 32.2917 16.225 32.2917 22Z"
      stroke="#2AA251"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.707 20.7508C20.1059 21.5949 20.6496 22.386 21.3382 23.0856C22.0269 23.7853 22.8055 24.3377 23.6362 24.743C23.7077 24.7778 23.7434 24.7953 23.7886 24.8086C23.9493 24.8562 24.1466 24.8221 24.2827 24.7231C24.3209 24.6952 24.3537 24.6619 24.4192 24.5954C24.6196 24.3918 24.7197 24.29 24.8205 24.2235C25.2004 23.9725 25.6901 23.9725 26.07 24.2235C26.1707 24.29 26.2709 24.3918 26.4713 24.5954L26.583 24.7088C26.8875 25.0183 27.0398 25.173 27.1225 25.3392C27.287 25.6696 27.287 26.0599 27.1225 26.3904C27.0398 26.5565 26.8875 26.7113 26.583 27.0207L26.4926 27.1125C26.1891 27.4209 26.0373 27.5751 25.831 27.6928C25.6021 27.8235 25.2465 27.9175 24.9839 27.9167C24.7472 27.9159 24.5855 27.8693 24.262 27.776C22.5236 27.2747 20.8832 26.3288 19.5147 24.9384C18.1462 23.5479 17.2152 21.8813 16.7218 20.115C16.63 19.7864 16.5841 19.6221 16.5834 19.3816C16.5826 19.1148 16.6751 18.7535 16.8037 18.5209C16.9196 18.3113 17.0713 18.1571 17.3749 17.8487L17.4652 17.7569C17.7698 17.4475 17.9221 17.2927 18.0856 17.2087C18.4109 17.0415 18.795 17.0415 19.1202 17.2087C19.2838 17.2927 19.4361 17.4475 19.7406 17.7569L19.8523 17.8704C20.0527 18.0739 20.1528 18.1757 20.2183 18.2781C20.4653 18.664 20.4653 19.1616 20.2183 19.5476C20.1528 19.65 20.0527 19.7517 19.8523 19.9553C19.7868 20.0219 19.754 20.0551 19.7266 20.0941C19.6292 20.2323 19.5956 20.4327 19.6424 20.596C19.6556 20.6419 19.6727 20.6782 19.707 20.7508Z"
      fill="#2AA251"
    />
  </svg>
);

export const alertTriangleIcon = (
  color = "#3F3F46",
  width = "24",
  height = "24",
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
